// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { MsgDecoder } from './Factory/MsgDecoder.js';
import { DataBuffer } from './DataBuffer.js';
import { SocketDataStream } from './BufferedProcessor/SocketDataStream.js';
import { FieldsFactory } from './Factory/FieldsFactory.js';
import { PFixFieldSet } from './Fields/FieldsImport.js';

import * as vendorMessage from './Messages/MessagesImport.js';
import { Message } from './Messages/MessagesImport.js';

import * as vendorGroup from './Groups/GroupsImport.js';

import * as directMessage from '../../../Utils/DirectMessages/DirectMessagesImport.ts';
import { DirectMessageCode } from '../../../Utils/DirectMessages/DirectMessagesImport.ts';

import { HistoryType } from '../../../Utils/History/HistoryType.ts';
import { Periods } from '../../../Utils/History/TFInfo.ts';
import { FINISH_BLOCK_TRANSFER } from '../../../Utils/CommonConst.js';
import { OrderType } from '../../../Utils/Trading/OrderType.js';

import { DirectPropertyOwner, InformationMessageType, SlTpPriceType, SubscribeType, SubscriptionSource } from '../../../Utils/Enums/Constants.js';

import { ErrorInformationStorage } from '../../../Commons/ErrorInformationStorage.js';
import { Connection } from '../../../Commons/Connection.js';

import { ServerMessaeContainer } from '../../../Controls/cache/FullLogsItem.js';

import { OperationType } from '../../../Utils/Trading/OperationType.ts';
import { OrderTif, TIF } from '../../../Utils/Trading/OrderTif.js';
import { PlacedFrom } from '../../../Utils/Trading/PlacedFrom.js';
import { InstrumentTypes } from '../../../Utils/Instruments/InstrumentType.js';
import { NO_BIND_TO } from '../../../Utils/Trading/OrderConstants.js';
import { StrategySubscriptionStatus } from '../../../Utils/TradingIdeas/StrategySubscriptionStatus.js';
import { RulesSet } from '../../../Utils/Rules/RulesSet.js';
import { BaseInterval } from '../../../Utils/History/BaseInterval.ts';
import { SLTPTrigger } from '../../../Utils/SlTpTrigger.js';
import { Quantity } from '../../../Utils/Trading/Quantity.js';
import { OrderEditBaseUtils, OrderEditRequestData } from '../../../Utils/Trading/OrderEditBaseUtils.js';
import { TradingLockUtils } from '../../../Utils/TradingLockUtils.js';
import { PriceLimitValidation } from '../../../Utils/Instruments/PriceLimitValidation.js';
import { ClientType } from '../../../Utils/ClientType.js';
import { UUID } from '../../../Utils/UUID.js';
import { ClusterNodeGroupContainer } from './GroupUtils/ClusterNodeGroupContainer.ts';


export let ProcessorWorker = function (mode)
{
    this.dataStream = null;
    this.isSSL = false;
    this.siteAddres = "";
    this.StreamMode = mode;// || ProcessorWorker.MODE_QUOTESTREAM;
    this.StreamKey = null;

    this.InstrumentsSubscribeFaltureTable = new Object();
    this.InstrumentsSubscribeFaltureTable.Count = 0;

    this.FMsgDecoder = new MsgDecoder(this);
    this.OnNewMessageDelegate = null;
    this.OnDisconnect = null;

    this.SessionId = "<Empty>";

    this.OnConnectionLost = null;
    this.OnError = null;


    // TODO. Implement or remove?
    this.parent = null;

    this.symbolSubscriptionDict = new Object();

    this.finished = false;
    this.nonFixedList = false;

    this.StreamModeStringName = "";
    this.CreateStringStreamModeName();

    this.FullLogHandler = null;

    this.WrappersHandlers = new Object();
    this.WrappersHandlersTrading = new Object();

    //this.RouteQuoteId_VS_RouteId = new Object();

    this.RoutesSupported = new Object();
    this.Address = "";
    this.QuoteAddresses = new Array();

    this.serverMaxFieldNumber = Number.MAX_VALUE;

    this.DelayedMessages = [];


    // this.myWorker = new Worker("scripts/Vendors/PFSVendor/WebFix/BufferedProcessor/TestWorker.js");
    // this.myWorker.onmessage = function (evt)
    // {
    //     let x = 0;
    // }
}

//#region stream main work

ProcessorWorker.prototype.SendMessage = function (pfixmsg)
{
    var buffer = new DataBuffer();
    var fieldSet = pfixmsg.FieldSet;
    var code = pfixmsg.Code;
    fieldSet.Write(buffer, this.serverMaxFieldNumber);

    var length = buffer.Length();
    var dv = new DataView(new ArrayBuffer(length + 4));

    //size
    dv.setInt32(0, length);

    //data
    var bytes = buffer.ReadAllBytes();
    for (var i = 0; i < length; i++)
        dv.setInt8(i + 4, bytes[i]);

    this.dataStream.SendData(dv.buffer, code);

    if (this.FullLogHandler)                //4th arg for outgoing message
        this.FullLogs(fieldSet, true, length, true)
}

//Moved to worker
ProcessorWorker.prototype.AppendData = function (data)
{
    var dv = new DataView(data);

    var currIndex = 0;
    while (currIndex < data.byteLength)
    {
        // длина мессаджа - 4 байта
        if ((data.byteLength - currIndex) < 4)
            return;

        var length = dv.getInt32(currIndex);
        currIndex += 4;

        // Копируем из массива данных бинарное сообщение и отправляем его
        var msg = this.CopyData(dv, currIndex, length);
        if (msg != null)
        {
            currIndex += length;
            this.Push(msg);
        }
        else
        {
            // в буфере не осталось достаточно символов - выходим
            currIndex -= 4;
            break;
        }
    }

}
//Moved to worker
ProcessorWorker.prototype.CopyData = function (dv, curIndex, count)
{
    if ((curIndex + count) <= dv.byteLength)
    {
        var newData = [];
        for (var i = 0; i < count; i++)
            newData[i] = dv.getInt8(curIndex++);
        return newData;
    }
    else
        return null;
}
//Moved to worker
ProcessorWorker.prototype.GetFieldSet = function (msg)
{
    var fieldSet = new PFixFieldSet();
    var buffer = new DataBuffer(msg);
    fieldSet.Read(buffer);
    return fieldSet;
}

ProcessorWorker.prototype.Push = function (bytes)
{
    var fs = this.GetFieldSet(bytes);

    if (this.FullLogHandler)
        this.FullLogs(fs, false, bytes.length);

    var messages = this.FMsgDecoder.Decode(fs);

    let rqi = fs.GetField(FieldsFactory.FIELD_REQUEST_ID);
    if (rqi)
        if (this.CheckIsHandled(rqi.Value, messages))
            return;

    if (Array.isArray(messages))
        for (let i = 0; i < messages.length; i++)
            if (messages[i])
            {
                if (!messages[i].IsDirect)
                {
                    let rqi = messages[i].FieldSet.GetField(FieldsFactory.FIELD_REQUEST_ID);
                    if (rqi)
                        if (this.CheckIsHandled(rqi.Value, messages[i]))
                            continue;
                }
                else if (messages[i].OrderNumber)
                    this.CheckIsTraidingHandled(messages[i].OrderNumber, messages[i]);
                else if (messages[i].RequestID)
                    this.CheckIsHandled(messages[i].RequestID, messages[i]);

                this.Notify(messages[i]);
            }
}

ProcessorWorker.SendMessageToVendor = function (url, isSSL, msgType, dataForMsg, FullLogHandler)
{
    if (!ProcessorWorker.prototype[msgType])
        return Promise.resolve(null);

    let stream = new ProcessorWorker(ProcessorWorker.MODE_TRADESTREAM);
    if (FullLogHandler)
        stream.FullLogHandler = FullLogHandler;

    stream.siteAddres = url;
    stream.isSSL = isSSL;
    return new Promise((resolve, reject) =>
    {
        stream.OnError = function ()
        {
            resolve(null);
        }
        return stream.OpenWS().then(function (opened)
        {
            if (!opened)
                return Promise.resolve(null);

            return stream[msgType](dataForMsg)
                .then(function (result)
                {
                    stream.Disconnect();
                    resolve(result);
                });
        })
    })
}


ProcessorWorker.prototype.CheckIsTraidingHandled = function (rqi, msg)
{
    let handler = this.WrappersHandlersTrading[rqi];
    if (!handler)
        return false;
    handler(msg);
    delete this.WrappersHandlersTrading[rqi];
    return true;
}

ProcessorWorker.prototype.CheckIsHandled = function (rqi, msg)
{
    let handler = this.WrappersHandlers[rqi];
    if (!handler)
        return false;
    handler(msg);
    delete this.WrappersHandlers[rqi];
    return true;
}
//#endregion


//#region  connect disconnect
ProcessorWorker.prototype.ConnectToServer = function (serverAdress, params)
{
    if (!serverAdress)
        return Promise.reject(this.CreateOpenWSError("No Server Adress", 14, 1003));

    return this.ConnectionInProcess(serverAdress, params);
}

ProcessorWorker.prototype.ConnectionInProcess = function (serverAdress, params)
{
    let self = this;

    self.isSSL = params.isSSL
    self.siteAddres = serverAdress;
    self.reconnect = params.reconnect;
    return self.OpenWS()
        .then(function (opened)
        {
            if (opened)
                return self.Connect(params);
            else
                return Promise.reject(self.CreateOpenWSError("Can't open stream", 13, 100));
        })
        .catch(function (connerr)
        {
            return Promise.reject(self.CreateOpenWSError(connerr.message, connerr.code, 1001));
        })
        .then(function (connectResult)
        {
            return Promise.resolve(connectResult)
        });

};

ProcessorWorker.prototype.CreateOpenWSError = function (errorText, logoutType, errorCode)
{
    let result = {}
    result.Text = errorText;
    result.LogoutType = logoutType;
    result.ErrorCode = errorCode;
    result.Connected = false;
    result.ErrorInConnection = true;
    return result;
}

//Moved to worker
ProcessorWorker.prototype.OpenWS = function (sert)
{
    let self = this;
    return new Promise(function (resolve, reject)
    {
        let delegates = new Object();
        delegates.OnOpenDelegate = self.StreamOpened.bind(self, resolve);
        delegates.OnCloseDelegate = self.StreamClosed.bind(self, resolve);
        delegates.OnErrorDelegate = self.StreamError.bind(self, resolve);
        delegates.OnMessageDelegate = self.AppendData.bind(self);

        let addresString = self.isSSL ? "wss://" : "ws://";
        addresString += self.siteAddres;
        addresString += "/websocket"
        let ws = sert ? new WebSocket(addresString, { ca: sert }) : new WebSocket(addresString);
        ws.binaryType = "arraybuffer";

        self.dataStream = new SocketDataStream(ws, delegates);
    });
}

ProcessorWorker.prototype.Disconnect = function (isNoNActivity)
{
    if (this.dataStream)
    {
        let disconnectMSG = new vendorMessage.LogoutMessage();
        disconnectMSG.setText(isNoNActivity ? "Disconnect due to inactivity" : "Disconnect.")
        this.SendMessage(disconnectMSG);
        this.dataStream.Dispose();
    }
    // if (this.myWorker)
    //     this.myWorker.terminate();
}

ProcessorWorker.prototype.CloseStream = function ()
{
    if (this.dataStream)
        this.dataStream.CloseStream();
}

//Moved to worker
ProcessorWorker.prototype.StreamOpened = function (resolve, isOpen)
{
    return resolve(true);
};

//Moved to worker
ProcessorWorker.prototype.StreamClosed = function (resolve)
{
    //this.Disconnect();
    if (!this.reconnect)
        return resolve(false);
};
//Moved to worker
ProcessorWorker.prototype.StreamError = function (resolve, isOpen)
{
    if (this.OnConnectionLost && this.finished)
        this.OnConnectionLost();

    if (this.OnError)   // TODO необходимо довести reject в ответ Promise-ов с помощью resolve(false);
        this.OnError(resolve);
};

ProcessorWorker.prototype.StreamException = function ()
{
    return resolve();
};
//#endregion


ProcessorWorker.prototype.Connect = function (connectionsParameters, accessToken)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let hello = new vendorMessage.HelloMessage();
        hello.setHello("hello");

        ProcessorWorker.AddProtocolVersonAndMaxField(hello);

        me.serverMaxFieldNumber = hello.getMaxFieldNumber();

        let rqi = hello.getSequance();
        hello.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(hello);

    })
        .then(function (helloAnswer)
        {
            return me.SendLogonMessage(connectionsParameters, helloAnswer[0], accessToken);
        })
        .then(function (logonAnswer)
        {
            return me.LogonAnswerProcess(logonAnswer[0]);
        });
}

async function makeKey (key)
{
    let enc = new TextEncoder().encode(key)
    return await crypto.subtle.importKey(
        "raw",
        enc,
        "AES-GCM",
        false, //whether the key is extractable (i.e. can be used in exportKey)
        ["encrypt", "decrypt"] //can "encrypt", "decrypt", "wrapKey", or "unwrapKey"
    )
}

async function encrypt (string, key)
{
    let encoded = new TextEncoder().encode(string);
    let iv = new Uint8Array([0x49, 0x32, 0x76, 0x61, 0x6e, 0x20, 0x11, 0x4d, 0x65, 0x64, 0x76, 0x65, 0x64, 0x65, 0x60, 0x76])
    let encrypted = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
            // tagLength: 128, //can be 32, 64, 96, 104, 112, 120 or 128 (default)
        },
        key, //from generateKey or importKey above
        encoded //ArrayBuffer of data you want to encrypt
    )
    return encrypted = { "encrypted": encrypted, "iv": iv };
}

async function EncodeKey_AES_GCM_NoPadding (string, key)
{
    let keyNew = await makeKey(key);
    let encrypted = await encrypt(string, keyNew);

    return btoa(String.fromCharCode(...new Uint8Array(encrypted.encrypted)));
}

ProcessorWorker.prototype.SendLogonMessage = function (connectionsParameters, helloAnswer, accessToken)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let hello = helloAnswer;

        let login = connectionsParameters.login || ''

        let Mode = me.StreamMode;
        let clientType = ClientType.getClientType();
        let additionalPassword = connectionsParameters.verificationPassword || null;
        let useGetInitDataRequest = Mode === ProcessorWorker.MODE_TRADESTREAM;
        let dateOfBuild = connectionsParameters.build_date_day || "16.04.2019";

        let prommises = [];
        let EncrType = hello.EncryptionType();
        let logon = new vendorMessage.LogonMessage();
        logon.setLogin(login);
        if (connectionsParameters.accessToken)
            logon.setAccessToken(connectionsParameters.accessToken);
        else
        {
            let pass = connectionsParameters.pass || ''
            let pr = null;
            if (EncrType !== EncrTypes.AES_GCM_NoPadding)
                pr = ProXOREncryptionUtility.Encode(pass, hello.getHello())
                    .then((encrPass) =>
                    {
                        logon.setPassword(encrPass)
                        return true;
                    });
            else
                pr = EncodeKey_AES_GCM_NoPadding(pass, hello.getHello())
                    .then((encrPass) =>
                    {
                        logon.setPassword(encrPass);
                        return true
                    })
            prommises.push(pr);
        }

        if (connectionsParameters.brandingKey)
        {
            let pr = null;
            if (EncrType !== EncrTypes.AES_GCM_NoPadding)
                pr = ProXOREncryptionUtility.Encode(connectionsParameters.brandingKey, hello.getHello())
                    .then((encrPass) =>
                    {
                        logon.setBrandingKey(encrPass)
                        return true;
                    });
            else
                pr = EncodeKey_AES_GCM_NoPadding(connectionsParameters.brandingKey, hello.getHello())
                    .then((encrPass) =>
                    {
                        logon.setBrandingKey(encrPass)
                        return true;
                    });
            prommises.push(pr);
        }

        if (connectionsParameters.ipURL)
        {
            logon.setIP(connectionsParameters.ipURL);
        }

        //new
        logon.setConnectionMode(Mode);
        logon.setClientType(clientType);
        if (additionalPassword)
            logon.setVerificationPassword(additionalPassword);

        if (connectionsParameters.ExternalResourse)
            logon.setExternalResourse(connectionsParameters.ExternalResourse);
        if (connectionsParameters.TokenID)
            logon.setTokenID(connectionsParameters.TokenID);

        logon.setCanISendGetInitDataRequest(useGetInitDataRequest);
        logon.setDateOfBuild(dateOfBuild);

        if (connectionsParameters.customerNo)
        {
            logon.SetCustomerNo(connectionsParameters.customerNo)
            logon.setExternalResourse(ExternalResource.OPTIMUS);
        }

        logon.SetAppInstallId(UUID.getAppInstallID());

        me.WrappersHandlers["logonResolve"] = resolve;

        Promise.all(prommises).then(() => { me.SendMessage(logon) });
    })
}


ProcessorWorker.prototype.HandleLogon = function (msg)
{

}

ProcessorWorker.prototype.LogonAnswerProcess = function (logonAnswer, useGetInitDataRequest)
{
    if (logonAnswer.Code === Message.CODE_PFIX_LOGON_MESSAGE)
        return this.LogonWorking(logonAnswer, useGetInitDataRequest);
    if (logonAnswer.Code === Message.CODE_PFIX_LOGOUT_MESSAGE)
        return this.LogoutWorking(logonAnswer, useGetInitDataRequest);
}

ProcessorWorker.prototype.LogonWorking = function (logon, useGetInitDataRequest)
{
    let userSessionId = logon.getSessionId();
    let login = logon.getLogin();
    let result = { userSessionId: userSessionId, login: login }

    this.SessionId = userSessionId;

    let clusterNodeGroups = logon.FieldSet.GetGroups(FieldsFactory.CLUSTER_NODE_GROUP, vendorGroup.ClusterNodeGroup);
    const clusterNodeGroupsContainer = new ClusterNodeGroupContainer(clusterNodeGroups);

    ////////Start////////
    let mess = new directMessage.DirectPropertyMessage();
    mess.Name = "startblocktransfer";
    mess.Value = "true";
    this.OnNewMessageDelegate(mess);

    let tradingUnlockLogic = logon.getTradingUnlockLogic()

    if (tradingUnlockLogic)     // #89340 & #94446
        TradingLockUtils.IsUseLockTradingByPassword = tradingUnlockLogic > 0

    if (tradingUnlockLogic === 2 || tradingUnlockLogic === 3) //use one time password
    {
        let useOnTimepassword = new directMessage.DirectPropertyMessage();
        useOnTimepassword.Name = RulesSet.FUNCTION_USE_ONE_TIME_PASSWORD;
        this.DelayedMessages.push(useOnTimepassword);
    }

    if (this.StreamMode === ProcessorWorker.MODE_TRADESTREAM)
        this.getInitData(logon, useGetInitDataRequest);

    //version 1.9
    let accessToken = logon.GetAccessToken();
    let accessTokenLifeTime = logon.GetAccessTokenLifeTime();
    let refreshToken = logon.GetRefreshToken();
    let refreshTokenLifeTime = logon.GetRefreshTokenLifeTime();

    result.Connected = !!userSessionId
    result.CngContainer = clusterNodeGroupsContainer;
    result.ErrorInConnection = false;
    result.isPasswordExpired = logon.isPasswordExpired();
    if (result.isPasswordExpired)
        result.UserID = logon.getFieldValue(FieldsFactory.FIELD_USER_ID);
    result.verificationMode = logon.getVerificationMode();

    result.accessToken = accessToken;
    result.accessTokenLifeTime = accessTokenLifeTime;
    result.refreshToken = refreshToken;
    result.refreshTokenLifeTime = refreshTokenLifeTime;

    return result;
}
ProcessorWorker.prototype.LogoutWorking = function (logout, useGetInitDataRequest)
{
    let result = {};

    let sessionId = logout.getSessionId();
    let errorText = logout.getText();
    let logoutType = logout.getLogoutType();
    let errorCode = logout.getErrorCode();

    result.Text = errorText;
    result.LogoutType = logoutType;
    result.ErrorCode = errorCode;
    result.Connected = false;
    result.ErrorInConnection = true;

    return result;
}


ProcessorWorker.prototype.getInitData = function (logon, useGetInitDataRequest)
{
    let nonFixedList = logon.getIsUnfixedList()
    if (nonFixedList === null)
        //сервер не поддерживает запрос
        return

    //this.SendExchanges()

    let pMsg = new directMessage.DirectPropertyMessage()
    pMsg.Name = RulesSet.FUNCTION_NON_FIXED_LIST
    pMsg.Value = nonFixedList ? 'true' : 'false'
    this.nonFixedList = nonFixedList;
    this.Notify(pMsg)

    let request = new vendorMessage.InitDataRequest()
    request.setMaxFieldNumber(FieldsFactory.getInstance().MaxFieldNumber)

    if (nonFixedList)
    {
        //remove
        let symbols = [];//['AUD/CAD']
        if (symbols.length > 0)
        {
            let instumentsGroup = new vendorGroup.InitDataRequestInstrumentsGroup()
            request.FieldSet.AddGroup(instumentsGroup)
            for (let i = 0; i < symbols.length; i++)
            {
                let gr = new vendorGroup.InstrumentNamesGroup()
                gr.setName(symbols[i])
                instumentsGroup.AddGroup(gr)
            }
        }
    }
    this.SendMessage(request)
}

ProcessorWorker.prototype.Notify = function (message)
{
    var messageReadData = null;
    var code = message.Code;
    if (message.IsDirect)
    {
        switch (message.Code)
        {
            case DirectMessageCode.CODE_ASSET_TYPE_MESSAGE:
                this.FMsgDecoder.AssetDecodeMap[message.Id] = message.Name;
                break;

            case DirectMessageCode.CODE_INSTRUMENT:
                let insID = message.ForwardBaseInstrumentID,
                    isOptionInNonFixedList = message.InstrType === InstrumentTypes.OPTIONS && insID !== null && insID !== -1 && this.nonFixedList,
                    instrumentMsgAlreadyReceived = this.FMsgDecoder.GetSymbolById(insID)   // #113128 
                if (isOptionInNonFixedList && !instrumentMsgAlreadyReceived)
                {
                    this.getInstrumentById(insID).then((messages) =>
                    {
                        for (let i = 0; i < messages.length; i++)
                            if (messages[i].Code === DirectMessageCode.CODE_INSTRUMENT)
                                this.OnNewMessageDelegate(messages[i]);
                    })
                    message.ForwardBaseInstrumentID = null;
                    return;
                }
                break;

            case DirectMessageCode.CODE_PROPERTY:
                this.handlePropertyMessage(message)
                return

            case DirectMessageCode.CODE_ACCOUNT_STATUS:
            case DirectMessageCode.CODE_BROKER_MESSAGE:
                message.ClusterNode = this.StreamKey;
                break;
        }

        this.OnNewMessageDelegate(message);
    }
    else
        switch (code)
        {
            case Message.CODE_PFIX_HELLO_MESSAGE:
            case Message.CODE_PFIX_LOGON_MESSAGE:
            case Message.CODE_PFIX_LOGOUT_MESSAGE:
                let handle = this.WrappersHandlers["logonResolve"];
                if (handle)
                    handle([message]);
                delete this.WrappersHandlers["logonResolve"];
                this.HandleLogon(message);

                if (Message.CODE_PFIX_LOGOUT_MESSAGE !== message.Code || handle)
                    break;

                let msg = new directMessage.DirectPropertyMessage();
                msg.Name = "LOGOUT";
                msg.Value = {
                    LogoutType: message.getLogoutType(),
                    ErrorCode: message.getErrorCode(),
                    Text: message.getText()
                };

                this.OnNewMessageDelegate(msg);
                break;
            case Message.CODE_PFIX_XML_MESSAGE:
                this.OnNewMessageDelegate(
                    ProcessorWorker.createDirectReportResponseMessage(message))
                break
        }
}

// TODO. Refactor.
ProcessorWorker.prototype.handlePropertyMessage = function (msg)
{
    let isFinishBlockTransfer = msg.Name === FINISH_BLOCK_TRANSFER
    if (isFinishBlockTransfer)
    {
        this.finished = true
        if (this.DelayedMessages && this.DelayedMessages.length)
        {
            for (let i = 0; i < this.DelayedMessages.length; i++)
                this.OnNewMessageDelegate(this.DelayedMessages[i]);
            this.DelayedMessages.length = 0;
        }
        this.trySendPropertyMessage(
            ProcessorWorker.createLocalRule(
                RulesSet.VALUE_THROTLING_PANEL_LIMIT_AGGRESSOR_BALANCE, '1'))

        if (this.useProductType)
            this.trySendPropertyMessage(
                ProcessorWorker.createLocalRule(
                    RulesSet.FUNCTION_USE_PRODUCT_TYPE, '1'))
    }

    this.trySendPropertyMessage(msg)
}

ProcessorWorker.prototype.trySendPropertyMessage = function (msg)
{
    if (!msg)
        return false

    let tradeStream = this.StreamMode & ProcessorWorker.MODE_TRADESTREAM
    let isFinishBlockTransfer = msg.Name === FINISH_BLOCK_TRANSFER

    if (isFinishBlockTransfer || tradeStream)
    {
        this.OnNewMessageDelegate(msg)
        return true
    }

    return false
}

ProcessorWorker.createLocalRule = function (name, value)
{
    let pm = new directMessage.DirectPropertyMessage()
    pm.OwnerType = DirectPropertyOwner.Local
    pm.Name = 'RULE'
    pm.Value = name + '=' + value
    return pm
}

// TODO. PFixMsgProcessor.cs->FindRequestTime()
ProcessorWorker.prototype.FindRequestTime = function (msg)
{
    return 0
}

ProcessorWorker.prototype.CreateStringStreamModeName = function ()
{
    let mode = "";
    if ((this.StreamMode & ProcessorWorker.MODE_QUOTESTREAM) > 0)
        mode += "Quote;";
    if ((this.StreamMode & ProcessorWorker.MODE_TRADESTREAM) > 0)
        mode += "Trade;";
    if ((this.StreamMode & ProcessorWorker.MODE_HISTORYSTREAM) > 0)
        mode += "History;";
    if ((this.StreamMode & ProcessorWorker.MODE_NEWSTREAM) > 0)
        mode += "News;";
    this.StreamModeStringName = mode;
}

// #region IQuote

// TODO. Generate lvl1 from lvl2, unsubscribe from lvl1 if lv2 sub exists.
// TODO. Are HistoryType constants ok here?
ProcessorWorker.prototype.SubscribeQuote = function (InstrumentId, route, service, forse, isDataSource)
{
    if (isDataSource)
        return

    if (!forse && this.subscribed(InstrumentId, route, service))
        return;

    let sent = this.trySendSubscriptionMessage(InstrumentId, route, service, SubscribeType.SUBSCRIBE)
    if (!sent) return


    //if (this.subscribed(InstrumentId, route, service))
    //    return;

    // DayBar message subscription #57649
    if (this.subscribed(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR))
        return

    if (!this.subscribed(InstrumentId, route, HistoryType.QUOTE_LEVEL1) &&
        !this.subscribed(InstrumentId, route, HistoryType.QUOTE_LEVEL2))
        return

    this.trySendSubscriptionMessage(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR, SubscribeType.SUBSCRIBE)
}

// TODO. Generate lvl1 from lvl2, unsubscribe from lvl1 if lv2 sub exists.
ProcessorWorker.prototype.UnsubscribeQuote = function (InstrumentId, route, service, forse, isDataSource)
{
    if (isDataSource)
        return

    let sent = this.trySendSubscriptionMessage(InstrumentId, route, service, SubscribeType.UNSUBSCRIBE)
    if (!sent) return

    //if (!this.subscribed(InstrumentId, route, service))
    //    return;

    // DayBar message unsubscription #57649
    if (!this.subscribed(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR))
        return

    if (this.subscribed(InstrumentId, route, HistoryType.QUOTE_LEVEL1) ||
        this.subscribed(InstrumentId, route, HistoryType.QUOTE_LEVEL2))
        return

    this.trySendSubscriptionMessage(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR, SubscribeType.UNSUBSCRIBE)
}

// TODO. Rename.
ProcessorWorker.prototype.trySendSubscriptionMessage = function (InstrumentId, route, service, subscriptionActionType, isDataSource, targetTrInsID)
{
    let group = this.createSubscribeGroup(InstrumentId, route, service, subscriptionActionType, isDataSource, targetTrInsID)
    if (!group) return false

    if (!this.trySetBaseSubscriptionArguments(group, InstrumentId, route, service))
        return false

    group.setGroupID(0);
    group.InstrumentTradableID = InstrumentId;
    group.Route = route;
    group.Service = service;

    if (service === 2 || service === 32)
        group.setSubscriptionPeriodicity(1);

    let message = new vendorMessage.SubscribeMessage()
    message.setSubscriptionAction(subscriptionActionType)
    message.FieldSet.AddGroup(group)

    let me = this
    let sendSubsHandler = new Promise(function (resolve, reject)
    {
        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(message);
    })
        .then(function (message)
        {
            let m = message[0] || message;
            if (!m)
                return;

            m.InstrumentId = InstrumentId
            m.Route = route

            // if (!m.ErrorCode)
            me.Notify(m);

            if (m.ErrorCode)
            {
                me.CheckErrorSubscribeResponse(group)
            }
            else if (group.Service === directMessage.DirectQuoteMessage.QUOTE_LEVEL2)
                me.CheckSuccessSubcribeResponse(group)
        })

    this.updateSymbolSubscriptionDict(InstrumentId, route, service, subscriptionActionType === SubscribeType.SUBSCRIBE)

    return true
}
ProcessorWorker.prototype.CheckErrorSubscribeResponse = function (group)
{
    if ((group.Service & directMessage.DirectQuoteMessage.QUOTE_LEVEL2) !== directMessage.DirectQuoteMessage.QUOTE_LEVEL2)
        return null;

    let tradableID = group.getTradableInstrumentId();
    let route = group.getRouteId();

    let dict = this.InstrumentsSubscribeFaltureTable[tradableID]
    if (!dict)
    {
        dict = new Object();
        this.InstrumentsSubscribeFaltureTable[tradableID] = dict;
        this.InstrumentsSubscribeFaltureTable.Count = Object.keys(this.InstrumentsSubscribeFaltureTable).length - 1;
    }
    dict[route] = directMessage.DirectQuoteMessage.QUOTE_LEVEL2;

    let processor = this.FMsgDecoder.FProcTable[Message.CODE_QUOTE]
    if (processor)
    {
        let q1Dic = processor.Quote1ValidDictionary;
        if (!q1Dic)
            return null;
        let rDict = q1Dic[route];
        if (!rDict)
            return null;
        let quote = rDict[tradableID];
        if (!quote)
            return null;
        quote.TradableId = tradableID;
        quote.QuoteRouteId = route;

        let q2 = directMessage.DirectQuote2Message.GetQute2MessagesFromQuote1ByDenyTable(quote, this.InstrumentsSubscribeFaltureTable);
        if (q2)
            this.Notify(q2);
    }

    return null;
}

ProcessorWorker.prototype.CheckSuccessSubcribeResponse = function (group)
{
    let tradableInstrumentId = group.getTradableInstrumentId()
    let SubsrDict = this.InstrumentsSubscribeFaltureTable[tradableInstrumentId];
    if (SubsrDict)
    {
        let route = group.getRouteId()
        let subscription = SubsrDict[route];
        if (subscription)
        {
            if (subscription === directMessage.DirectQuoteMessage.QUOTE_LEVEL2)
            {

                SubsrDict[route] = null;
                delete SubsrDict[route];
            }
        }
        if (!Object.keys(SubsrDict).length)
            delete this.InstrumentsSubscribeFaltureTable[tradableInstrumentId]
    }
}
ProcessorWorker.prototype.GetAvancedTable = function ()
{
    return this.InstrumentsSubscribeFaltureTable;
}

ProcessorWorker.prototype.createSubscribeGroup = function (InstrumentId, route, services, subscriptionActionType, isDataSource, targetTrInsID)
{
    // TODO. Option SubscribeGroup.
    // ...

    let group = new vendorGroup.SubscribeGroup();

    if (isDataSource)
    {
        group.setDataSource(SubscriptionSource.DATASOURCE)
        group.setTargetTradableId(targetTrInsID, SubscriptionSource.DATASOURCE, subscriptionActionType)
    }

    return group;
}

ProcessorWorker.prototype.SendDataSourceSubscriptionMessage = function (InstrumentId, route, service, subscriptionActionType, targetTrInsID)
{
    let toSubscribe = subscriptionActionType == SubscribeType.SUBSCRIBE
    if (this.subscribed(InstrumentId, route, service) == toSubscribe)
        return;

    this.trySendSubscriptionMessage(InstrumentId, route, service, subscriptionActionType, true, targetTrInsID)
}

ProcessorWorker.prototype.trySetBaseSubscriptionArguments = function (group, InstrumentId, route, service)
{
    let msgDecoder = this.FMsgDecoder

    group.setTradableInstrumentId(InstrumentId);

    // id требуемого роута
    let routeId = route
    //id соотв котировочного роута
    let quoteId = msgDecoder.GetRouteQuoteId(routeId)

    //if (routeId !== quoteId)
    //    this.RouteQuoteId_VS_RouteId[quoteId] = route;

    group.setRouteId(quoteId)
    group.setSubscriptionType(service)
    group.setLight(false)

    return true
}

// TODO. Rename.
ProcessorWorker.prototype.updateSymbolSubscriptionDict = function (InstrumentId, route, service, subscribed)
{
    let symSubsDict = this.symbolSubscriptionDict
    if (!symSubsDict[route])
        symSubsDict[route] = new Object();

    let insItem = symSubsDict[route][InstrumentId];

    if (!insItem)
    {
        insItem = new Object();
        symSubsDict[route][InstrumentId] = insItem;
    }

    if (subscribed)
        insItem[service] = true
    else
        delete insItem[service]
}

ProcessorWorker.prototype.subscribed = function (InstrumentId, route, service)
{
    let symSubsDict = this.symbolSubscriptionDict
    let serviceSetRoute = symSubsDict[route]
    if (!serviceSetRoute)
        return false;

    let serviceSetInstrumentId = serviceSetRoute[InstrumentId]
    if (!serviceSetInstrumentId)
        return false;

    return !!serviceSetInstrumentId[service];
}

// #endregion IQuote

ProcessorWorker.prototype.FullLogs = function (fs, output, msgLength, isOutgoingMessage)
{
    let container = new ServerMessaeContainer();
    container.MessageCode = fs.GetField(0).Value;
    container.MessageName = FieldsFactory.GetMsgTypeName(container.MessageCode);
    container.Text = fs.toString();
    container.TextNew = fs.ToStringView();
    container.DataForTreeView = fs.GetData();
    container.Side = output ? ServerMessaeContainer.ServerMessaeSide.Output : ServerMessaeContainer.ServerMessaeSide.Input;
    container.Length = msgLength;
    container.Mode = this.StreamMode;
    container.StringMode = this.StreamModeStringName;
    container.IsOutgoingMSG = !!isOutgoingMessage;

    //TODO
    //if (FDialogHolder != null)
    //{
    container.Session = this.SessionId;
    container.NodeAddress = this.siteAddres;
    //}
    this.FullLogHandler(container);
}

ProcessorWorker.prototype.SubscribeCrossRates = function ()
{
    let message = new vendorMessage.SubscribeCrossRateMessage();
    message.setSubscriptionAction(SubscribeType.SUBSCRIBE);
    this.SendMessage(message);
}

//#region Encrypt
var ProXOREncryptionUtility = function () { };
ProXOREncryptionUtility.Encode = function (dataInput, keyInput)
{
    return new Promise((resolve, reject) =>
    {
        let data = ProXOREncryptionUtility.GetBytes(dataInput);
        let key = ProXOREncryptionUtility.GetBytes(keyInput);
        let cipher = new Array(data.length);
        let realKey = new Array(data.length);
        let mask = [0x49, 0x32, 0x76, 0x61, 0x6e, 0x20, 0x11, 0x4d, 0x65, 0x64, 0x76, 0x65, 0x64, 0x65, 0x60, 0x76];

        for (let i = 0; i < realKey.length; i++)
            realKey[i] = (key[i % key.length] ^ mask[i % mask.length]);

        for (let i = 0; i < data.length; i++)
            cipher[i] = (data[i] ^ realKey[i]);

        let u8 = new Uint8Array(cipher)
        resolve(btoa(String.fromCharCode.apply(null, u8)));
    })
}

ProXOREncryptionUtility.GetBytes = function (data)
{
    let result = new Array();
    for (let i = 0; i < data.length; i++)
        result.push(data.charCodeAt(i));
    return result;
}
//#endregion Encrypt

////////History Work

//#region History Work

ProcessorWorker.prototype.ApplySpreadToBaseInterval = function (historyParams, bidBaseIntervals, askBaseIntervals, instr)
{
    if (instr == null)
        return;

    if (bidBaseIntervals == null && askBaseIntervals == null)
        return;

    let spreadPlan = historyParams.Plan;
    let period = historyParams.TimeFrameInfo.Periods;

    if (bidBaseIntervals == null || askBaseIntervals == null) //кейс, когда не нужна вторая часть истории для спредирования
    {
        let intervalsToSpread = bidBaseIntervals ? bidBaseIntervals : askBaseIntervals;
        let historyType = bidBaseIntervals != null ? HistoryType.QUOTE_LEVEL1 : HistoryType.QUOTE_ASK;
        for (let i = 0; i < intervalsToSpread.length; i++)
            intervalsToSpread[i].ApplySpread(spreadPlan, instr, period, historyType, null);

        return;
    }

    let askIndex = 0;
    if (historyParams.Plan != null)
    {
        for (let i = 0; i < bidBaseIntervals.length; i++)
        {
            let bidBi = bidBaseIntervals[i];
            let askBi = askBaseIntervals.length > askIndex ? askBaseIntervals[askIndex] : null;

            if (bidBi != null && askBi != null && bidBi.FLeftTimeTicks == askBi.FLeftTimeTicks)
            {
                //hsa: почему мы брали HistoryType из TimeFrameInfo?
                //ведь в случае запросы истории по аскам мы спредировали данные наоборот - биды как аски, а аски как биды
                bidBi.ApplySpread(spreadPlan, instr, period, HistoryType.QUOTE_LEVEL1, askBi);
                askIndex++;
            }
        }
    }
}

// TODO. Ugly. Refactor.
// Details are in XMLMessageProcessor.js.
ProcessorWorker.createDirectReportResponseMessage = function (pfixXmlMessage)
{
    let msg = new directMessage.DirectReportResponseMessage()
    if (pfixXmlMessage.length && pfixXmlMessage[0].Code === 14)
        return null;

    msg.xmlString =
        pfixXmlMessage.getFieldValue(FieldsFactory.FIELD_XML_BODY) ||
        LineGroup.getLongText(pfixXmlMessage.FieldSet)

    return msg
}

ProcessorWorker.createDirectReportGroupResponseMessage = function (pfixMessage)
{
    if (!pfixMessage)
        return null;

    pfixMessage = pfixMessage[0] || pfixMessage
    if (!pfixMessage)
        return null;

    let msg = pfixMessage.getDirectReportGroupResponse()
    return msg
}

ProcessorWorker.prototype.generateReportPromise = function (reportId, params)
{
    if (this.serverMaxFieldNumber >= FieldsFactory.FIELD_REPORT_ID)
        return this.requestReportPromise(reportId, params)
            .then(ProcessorWorker.createDirectReportGroupResponseMessage)
    else
        return this.requestOldReportPromise(reportId, params)   // старая схема
            .then(ProcessorWorker.createDirectReportResponseMessage)
}

ProcessorWorker.prototype.requestReportPromise = function (reportId, params)
{
    let ff = FieldsFactory
    let request = new vendorMessage.ReportGroupRequestMessage()

    let reqId = request.getSequance()
    request.setRequestId(reqId)

    if (params.locale)
        request.setFieldValue(ff.FIELD_LANG, params.locale)

    if (params.reportTypeObj && params.reportTypeObj.id)
    {
        request.setReportId(params.reportTypeObj.id)
    }

    request.setIsTechnicalReport(!!params.IsTechnical)

    let pDict = params.mainParamDict
    for (let key in pDict)
    {
        let paramGroup = new vendorGroup.KeyValueGroup()
        paramGroup.setKey(key)
        paramGroup.setValue(pDict[key])

        request.addGroup(paramGroup)
    }

    let self = this
    return new Promise(function (resolve, reject)
    {
        self.WrappersHandlers[reqId] = resolve
        self.SendMessage(request)
    })
}

ProcessorWorker.prototype.requestOldReportPromise = function (reportId, params)
{
    let ff = FieldsFactory
    let request = new vendorMessage.ReportRequestMessage()

    let reqId = request.getSequance()
    request.setRequestId(reqId)
    // +++ server should return time always in UTC
    request.setFieldValue(ff.FIELD_TYPE, 1)
    // по умолчанию реквестим имя инструмента с алиасами, но в некоторых случаях,
    // нам нужно истинное, серверное имя
    if (params.locale)
        request.setFieldValue(ff.FIELD_LANG, params.locale)
    request.setTemplateName(reportId)

    if (params.reportTypeObj && params.reportTypeObj.id)
    {
        let repTypeGroup = new vendorGroup.KeyValueGroup()
        repTypeGroup.setKey('reporttype')
        repTypeGroup.setValue(params.reportTypeObj.id.toString())

        request.addGroup(repTypeGroup)
    }

    let pDict = params.mainParamDict
    for (let key in pDict)
    {
        let paramGroup = new vendorGroup.KeyValueGroup()
        paramGroup.setKey(key)
        paramGroup.setValue(pDict[key])

        request.addGroup(paramGroup)
    }

    let self = this
    return new Promise(function (resolve, reject)
    {
        self.WrappersHandlers[reqId] = resolve
        self.SendMessage(request)
    })
}

//#endregion History Work

////////////TODO////////////
// ProcessorWorker.prototype.FillParamsTable = function (stream, historyParams, mode, paramsTable)
// {
//     if (paramsTable != null)
//     {
//         if (string.IsNullOrEmpty(historyParams.AnotherConnectionURL) && FProcessor != null)
//             FProcessor.CreateHistoryParams(historyParams, "history", paramsTable);
//         else if (!string.IsNullOrEmpty(historyParams.AnotherConnectionURL))
//         {
//             PFSFXMsgProcessor.CreateHistoryParams(historyParams.AnotherConnectionURL, historyParams.AnotherConnectionURL.StartsWith("https:"), historyParams.AnotherConnectionInstrumentID, historyParams, "history", paramsTable);
//             paramsTable["l"] = historyParams.AnotherConnectionLogin;
//             paramsTable["md5p"] = EncryptPassword(historyParams.AnotherConnectionPassword, historyParams.CryptType);
//         }

//         if (paramsTable.ContainsKey("r")) //#48726 - мы должны получить ссылку на котировочный роут, иначе данные не загрузятся
//         {
//             let processor = stream;
//             if (processor != null)
//                 paramsTable["r"] = processor.GetQuoteRouteName(paramsTable["r"]);
//         }

//         paramsTable["workMode"] = mode;
//     }
// }

ProcessorWorker.GetUnifiedAddress = function (address, secure = null)
{
    let default_port = "80";
    //отрезаем приставки, мешающие правильному разбору
    let hostName = address.trim(' ');
    if (hostName.startsWith("http://"))
        hostName = hostName.slice(0, 7);

    // +++ http://tp3.pfsoft.lan/entity/23449
    if (secure !== null)
    {
        if (secure)
        {
            if (hostName.startsWith("https://"))
                hostName = hostName.slice(0, 8);
            default_port = "443";
        }
    }
    else if (hostName.startsWith("https://"))
    {
        hostName = hostName.slice(0, 8);
        default_port = "443";
    }

    if (hostName.startsWith("www."))
        hostName = hostName.slice(0, 4);

    let index = hostName.indexOf('/');
    if (index > 0)
        hostName = hostName.slice(index);


    //определяем порт
    let parts = hostName.split(':');
    let hostNameOrIP = parts[0];
    let port = parts.length > 1 ? parts[1] : default_port;

    //TODO кажется ненужно, перформанс немного подъедает
    //let regex = new RegExp("^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$");
    //if (!regex.test(hostNameOrIP))
    //{
    //    try
    //    {
    //        console.log("Host Name Or IP");
    //        ////преобразуем символьное имя в IP
    //        //let entry = Dns.Resolve(hostNameOrIP);
    //        //if (entry.AddressList.length > 0)
    //        //    hostNameOrIP = entry.AddressList[0].ToString();
    //    }
    //    catch (ex)
    //    {
    //        //Utils.log(ex);
    //    }
    //}

    return hostNameOrIP + ":" + port;
}

ProcessorWorker.prototype.AccountOperationRequest = function (data)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.AccountOperationRequestMessage();

        message.setAccountId(data.accountId);
        message.setCounterId(data.counterId);
        message.setAmount(data.amount);
        message.setComment(data.comment);
        message.setOperationType(data.operationType, me.serverMaxFieldNumber);

        if (data.assetId)
            message.assetId(data.assetId);

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    }).then(function (msg)
    {
        return msg;
    });
}

// #region NFL - NonFixedList

ProcessorWorker.prototype.GetInstrumentList = function (patern, exchangeIDs, instrumentTypes, generateStrikes, searchInDescription, aliasLanguage, isOldLookupType)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.NonFixedInstumentListRequest(null, me.serverMaxFieldNumber, aliasLanguage);

        message.setFilterName(patern);
        message.setExchangeIDs(exchangeIDs);
        message.setInstrumentTypes(instrumentTypes);
        message.setSymbolLookupType(isOldLookupType) // пока сервер не обновился нельзя добавлять данное поле иначе ломается запрос

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    });
}

ProcessorWorker.prototype.GetYieldRate = function (instrumentID, routeID)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.YTMRequestMessage();
        message.setInstrumentId(instrumentID);
        message.setRouteId(routeID);

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    });
}

ProcessorWorker.prototype.SendExerciseRequest = function (positionID, status)
{
    let message = new vendorMessage.ExerciseRequestMessage();

    message.setPositionID(positionID)
    message.setStatus(status)

    this.SendMessage(message)
}

ProcessorWorker.prototype.SendInactivityPeriodState = function (msgText)
{
    let message = new vendorMessage.InformationMessage();
    message.setMsgType("info");
    message.setContent([JSON.stringify({ info: msgText })])
    message.setTimeSpan(new Date());
    this.SendMessage(message)
}

ProcessorWorker.prototype.SendLogsWhenSettingsWasChanged = function (propsForLog)
{
    let message = new vendorMessage.InformationMessage();
    message.setMsgTypeId(InformationMessageType.Settings)
    message.setContent([JSON.stringify(propsForLog)])
    message.setTimeSpan(new Date()); // #111674
    this.SendMessage(message)
}

ProcessorWorker.prototype.CreateMarginGroup = function (accountId, instrumentID, routeID, amount, price, stopPrice, orderType, operationMode, marginMode, productType, leverage)
{
    let group = new vendorGroup.MarginGroup();

    group.setAccountId(accountId);
    group.setTradableInstrumentID(instrumentID);
    group.setRouteId(routeID);
    group.setAmount(amount);

    if (price != null)
        group.setPrice(price);

    if (stopPrice != null)
        group.setStopPrice(stopPrice);

    if (orderType)  // #104724 risks&fees инфо может приходить и без orderType
        group.setOrderType(orderType);
    group.setOperationMode(operationMode);
    group.setMarginMode(marginMode);
    group.setProductType(productType);

    if (leverage)
        group.setLeverage(leverage)

    return group;
}


ProcessorWorker.prototype.SendMarginRequest = function (accountId, instrumentID, routeID, amount, price, stopPrice, orderType, productType, leverage)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.MarginRequestMessage()

        let group1 = me.CreateMarginGroup(accountId, instrumentID, routeID, amount, price, stopPrice, orderType, 1, 7, productType, leverage),
            group2 = me.CreateMarginGroup(accountId, instrumentID, routeID, amount, price, stopPrice, orderType, 2, 7, productType, leverage)

        message.addGroup(group1)
        message.addGroup(group2)

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    })
}

ProcessorWorker.prototype.SendPortfolioStatisticsRequest = function (accountId, type, startTime, endTime, routeId, instrumentTradableID)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.PortfolioStatisticsRequest()

        message.setAccountId(accountId)
        message.setType(type)
        message.setStartTime(startTime)
        message.setEndTime(endTime)
        message.setRouteId(routeId)
        message.setInstrumentTradableId(instrumentTradableID)

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    })
}

ProcessorWorker.prototype.SendNewsSubscribeMessage = function (routeIDArr, subscribeType)
{
    let message = new vendorMessage.NewsSubscribeMessage();
    message.setSubscriptionAction(subscribeType);

    if (routeIDArr)
        for (let i = 0; i < routeIDArr.length; i++)
            message.addRouteId(routeIDArr[i]);

    this.SendMessage(message);
}

ProcessorWorker.prototype.SendNewsRequestMessage = function (routeID, number, startTime, endTime)
{
    return new Promise((resolve, reject) =>
    {
        let message = new vendorMessage.NewsRequestMessage()

        message.setRouteId(routeID)
        message.setNumber(number)
        message.setStartTime(startTime)
        message.setEndTime(endTime)

        message.setSymbol('')
        message.setSource('')
        message.setNewsCategory('')
        message.setPriority(0)
        message.setTheme('')
        message.setIsUpperCaseSearch(true)
        message.setIsContentSearch(false)
        message.setIsEventSearch(false)

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        this.WrappersHandlers[rqi] = resolve;

        this.SendMessage(message)
    }).then((msg) =>
    {
        return msg.length ? msg[0] : msg;
    })
}

ProcessorWorker.prototype.SendPortfolioModelRequest = function ()
{
    let message = new vendorMessage.PortfolioModelRequest()
    this.SendMessage(message)
}

ProcessorWorker.prototype.AlgorithmSubscribeMessage = function (subscribe, algorithmId)
{
    let msg = new vendorMessage.AlgorithmSubscribeMessage();
    msg.setAlgorithmId(algorithmId);
    msg.setSubscribeAction(subscribe);

    let rqi = msg.getSequance();
    msg.setRequestId(rqi);

    let me = this,
        sub = subscribe,
        algID = algorithmId
    return new Promise(function (resolve, reject)
    {
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(msg);
    }).then(function (msgArr)
    {
        if (!msgArr)
            return

        let msg = msgArr.length ? msgArr[0] : msgArr
        if (msg.BusinessRejectCode == vendorMessage.BusinessRejectMessage.REQUEST_CODE_IS_NOT_SUPPORTED)  // https://tp.traderevolution.com/entity/109058 COMMENT
            Connection.vendor.AlgorithmSubscribeMessage(sub, algID, false)
    });
}

ProcessorWorker.prototype.SendTradingSignalRequest = function ()
{
    let message = new vendorMessage.TradingSignalRequestMessage();
    this.SendMessage(message)
}

ProcessorWorker.prototype.SendTradingSignalSeenRequest = function (tradingSignalId)
{
    let message = new vendorMessage.TradingSignalSeenRequestMessage();
    message.setTradingSignalId(tradingSignalId)
    this.SendMessage(message)
}

ProcessorWorker.prototype.SendSubscriptionStrategyRequest = function (tradingSystemId)
{
    let message = new vendorMessage.SubscriptionStrategyRequestMessage();
    message.setTradingSystemId(tradingSystemId)
    message.setTradingStrategySubscriptionStatus(StrategySubscriptionStatus.Accepted)
    this.SendMessage(message)
}

ProcessorWorker.prototype.SendSnapshotRequestMessage = function (tradableID, routeID)
{
    let message = new vendorMessage.SnapshotRequestMessage();
    message.setInstrumentTradableID(tradableID)
    message.setRouteId(routeID)
    this.SendMessage(message)
}

ProcessorWorker.prototype.GetBrandingRules = function (brandingKey)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.BrandingRulesRequestMessage();
        message.setBrandingKey(brandingKey);
        ProcessorWorker.AddProtocolVersonAndMaxField(message)
        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    });
}

ProcessorWorker.prototype.SendBrokerMessageReport = function (inputMessage, type)    // закоментовано, згодом відновлено  згідно з #110904 (для urgent BM було додано логіювання у #84587, судячи з усього зараз ця логіка вже є застарілою і непотрібною) 
{
    let message = new vendorMessage.BrokerMessage();
    message.setType(type);
    message.setSenderId(inputMessage.TargetID);
    message.setTargetId(inputMessage.SenderID);
    message.setId(inputMessage.ID);
    message.setDate(inputMessage.Date);

    let msgText = "<status refobj=\"message\"" + " refid=\"" + inputMessage.ID + "\"><field name=\"reacted\" value=\"true\"/></status>";
    message.setText(msgText);

    this.SendMessage(message);
}

ProcessorWorker.prototype.SendBrokerResponseMessage = function (brokerMsgID, value, userID, userName, responseType)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.BrokerResponseMessage();

        message.setId(brokerMsgID);
        message.setValue(value);
        message.setUserID(userID);
        message.setUsername(userName);
        if (responseType !== null)
            message.setResponseType(responseType);

        ProcessorWorker.AddProtocolVersonAndMaxField(message);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    });
}

ProcessorWorker.prototype.SendBrokerMessageHistoryRequest = function (userID)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.BMHistoryRequestMessage();

        message.setUserID(userID);

        ProcessorWorker.AddProtocolVersonAndMaxField(message);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    }).then(function (msg)
    {

        return msg
    })
}

ProcessorWorker.prototype.GetNonFixedInstrumentStrikes = function (ContractID)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.NonFixedInstumentStrikesRequest();

        message.setContractID(ContractID);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    });
}

ProcessorWorker.prototype.getInstrumentByNameNFL = function (instrumentName)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.NonFixedNewInstumentRequest();

        message.setInstrumentName(instrumentName);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    }).then(function (msg)
    {
        if (!msg.length)
            return null;
        if (msg[0].Code !== DirectMessageCode.CODE_INSTRUMENT)
            return null;
        let message = msg[0];
        if (message.InstrType === InstrumentTypes.OPTIONS && message.ForwardBaseInstrumentID !== null && message.ForwardBaseInstrumentID !== -1)
        {
            return me.getInstrumentById(message.ForwardBaseInstrumentID).then(function (msgBaseID)
            {
                //message.ForwardBaseInstrumentID_ = message.ForwardBaseInstrumentID;
                message.ForwardBaseInstrumentID = null;
                return msgBaseID.concat(msg);
            });
        }

        return msg;
    });
}

ProcessorWorker.prototype.getInstrumentByInstrumentTradableID_NFL = function (InstrumentTradableID)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.NonFixedNewInstumentRequest();

        message.setInstrumentTradableID(InstrumentTradableID);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    }).then(function (msg)
    {
        if (!msg.length)
            return null;
        if (msg[0].Code !== DirectMessageCode.CODE_INSTRUMENT)
            return null;
        let message = msg[0];
        if (message.InstrType === InstrumentTypes.OPTIONS && message.ForwardBaseInstrumentID !== null && message.ForwardBaseInstrumentID !== -1)
        {
            return me.getInstrumentById(message.ForwardBaseInstrumentID).then(function (msgBaseID)
            {
                //message.ForwardBaseInstrumentID_ = message.ForwardBaseInstrumentID;
                message.ForwardBaseInstrumentID = null;
                return msgBaseID.concat(msg);
            });
        }

        return msg;
    });
}


ProcessorWorker.prototype.GetNonFixedInstrumentListByAssetName = function (AsssetName)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.NonFixedInstumentListRequest(null, me.serverMaxFieldNumber);

        message.setAssetName(AsssetName);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    })
}

ProcessorWorker.prototype.getInstrumentById = function (instrumentID)
{
    return new Promise((resolve, reject) =>
    {
        let message = new vendorMessage.NonFixedNewInstumentRequest();
        message.setInstrumentID(instrumentID);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        this.WrappersHandlers[rqi] = resolve;
        this.SendMessage(message)
    });
}


ProcessorWorker.prototype.GetInstrument = function ()
{

}

// #endregion NFL

ProcessorWorker.prototype.SendPing = function ()
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.PingMessage();
        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(message)
    });
}

ProcessorWorker.prototype.SendRefreshTokenMsg = function (token)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.RefreshTokenMesage();
        let rqi = message.getSequance();
        message.setRequestId(rqi);
        message.SetRefreshToken(token);
        ProcessorWorker.AddProtocolVersonAndMaxField(message)
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(message)
    })
        .then(function (msg)
        {
            let msg0 = msg[0];
            if (!msg0)
                return null;
            if (msg0.Code === Message.CODE_PFIX_REFRESH_TOKEN)
            {
                let TokenDataObj = {};
                TokenDataObj.Valid = true;
                TokenDataObj.StreamOpened = true;
                TokenDataObj.accessToken = msg0.GetAccessToken();
                TokenDataObj.accessTokenLifeTime = msg0.GetAccessTokenLifeTime();
                TokenDataObj.refreshToken = msg0.GetRefreshToken();
                TokenDataObj.refreshTokenLifeTime = msg0.GetRefreshTokenLifeTime();
                return TokenDataObj;
            }

            return { Valid: false, StreamOpened: true };
        });
}

ProcessorWorker.prototype.ChangePassword = function (curPwd, newPwd, UserID, verificationPassword, accessToken)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.ChangePasswordMessage();
        message.setUserId(UserID);
        message.setPassword(curPwd);
        message.setNewPassword(newPwd);

        if (accessToken)
            message.setAccessToken(accessToken); // #92068

        ProcessorWorker.AddProtocolVersonAndMaxField(message)

        if (verificationPassword)
            message.setVerificationPassword(verificationPassword);

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(message)
    }).then(function (message)
    {
        if (!message)
            return null
        let mess = message[0];
        if (mess.IsDirect && mess.Data)
            return { Data: mess.Data, RejectCode: mess.BusinessRejectCode, status: 10000, errText: mess.Data[0][1] };

        let status = mess.getFieldValue(FieldsFactory.FIELD_CHANGE_PWD_STATUS);
        let minLength = mess.getFieldValue(FieldsFactory.FIELD_MIN_PASSWORD_LENGTH);
        let maxLength = mess.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH);
        if (status !== null)
            return { Status: status, MinLength: minLength, MaxLength: maxLength };

        return null
    }).catch(function ()
    {
        let ex = new CustomErrorClass("ProcessorWorker changePassword error", "ProcessorWorker.ChangePassword", "ChangePassword -> Promise");
        ErrorInformationStorage.GetException(ex);

        return null
    });


}

ProcessorWorker.prototype.ChangeTradingPassword = function (curPwd, newPwd)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.ChangeTradingPasswordMessage();
        message.setPassword(curPwd);
        message.setNewPassword(newPwd);

        ProcessorWorker.AddProtocolVersonAndMaxField(message)

        let rqi = message.getSequance();
        message.setRequestId(rqi);
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(message)
    }).then(function (message)
    {
        if (!message)
            return null
        let mess = message[0];
        if (mess.IsDirect && mess.Data)
            return { Data: mess.Data, RejectCode: mess.BusinessRejectCode, status: 10000, errText: mess.Data[0][1] };

        let status = mess.getFieldValue(FieldsFactory.FIELD_CHANGE_PWD_STATUS);
        let minLength = mess.getFieldValue(FieldsFactory.FIELD_MIN_PASSWORD_LENGTH);
        let maxLength = mess.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH);
        if (status !== null)
            return { Status: status, MinLength: minLength, MaxLength: maxLength };

        return null
    }).catch(function ()
    {
        let ex = new CustomErrorClass("ProcessorWorker changeTradingPassword error", "ProcessorWorker.ChangeTradingPassword", "ChangeTradingPassword -> Promise");
        ErrorInformationStorage.GetException(ex);

        return null
    });


}

ProcessorWorker.prototype.SendInformationMessage = function (data)
{
    let message = new vendorMessage.InformationMessage()
    message.setMsgType(data.msgType)
    message.setContent([JSON.stringify(data.content)])
    message.setTimeSpan(data.timestamp)

    this.SendMessage(message)
}
// #region Trading

// TODO. Answer. Promise.
// Refactor.
ProcessorWorker.prototype.modifyPosition = function (data)
{
    let changed = false;
    let newSLTP = data.parameterDict.sltp
    let position = data.position

    let positionHasSL = !!position.SLOrder
    let positionHasTP = !!position.TPOrder

    let setNewSL = !isNaN(newSLTP.StopLossPriceValue);
    let setNewTP = !isNaN(newSLTP.TakeProfitPriceValue);
    let setTrailingStop = newSLTP.StopLossPriceType === SlTpPriceType.TrOffset

    // TODO. Ugly. Details are at the top OrderEditBase.js
    let canEditSLOrTrailingStop = data.canEditSLOrTrailingStop
    let canEditTP = data.canEditTP

    let promises = []

    // Cancel SL.
    if (canEditSLOrTrailingStop && positionHasSL && !setNewSL)
    {
        this.cancelOrder(position.SLOrder, data.placedFrom)
        changed = changed || true;
    }

    // Cancel TP.
    if (canEditTP && positionHasTP && !setNewTP)
    {
        this.cancelOrder(position.TPOrder, data.placedFrom)
        changed = changed || true;
    }

    let orderTypes = OrderType,
        stopLossLimitValue = newSLTP.StopLossLimitPriceValue,
        needSetSLL = stopLossLimitValue != null,
        stopOrderType = needSetSLL ? orderTypes.StopLimit : orderTypes.Stop    // #91413

    // Place SL.
    if (canEditSLOrTrailingStop && setNewSL && !positionHasSL)
    {
        let slData = this.createDataForPlacingPositionSLTPOrder(
            data,
            setTrailingStop ? orderTypes.TrailingStop : stopOrderType,
            data.placedFrom)

        slData.parameterDict[setTrailingStop ? OrderEditBaseUtils.TRAILING_STOP_PARAM : OrderEditBaseUtils.STOP_PRICE_PARAM] =
            newSLTP.StopLossPriceValue

        if (needSetSLL)
            slData.parameterDict[OrderEditBaseUtils.LIMIT_PRICE_PARAM] = stopLossLimitValue

        if (newSLTP.RealTrStopPrice)
            slData.parameterDict.RealTrStopPrice = newSLTP.RealTrStopPrice;

        slData.parameterDict[OrderEditBaseUtils.SLTP_TRIGGER] = SLTPTrigger.GetRawValue(newSLTP.SLTPTriggerShortValue, data.side, true)

        this.placeSLTPOrderForPosition(slData, position, data.placedFrom)

        changed = changed || true;
    }

    // Place TP.
    if (canEditTP && setNewTP && !positionHasTP)
    {
        let tpData = this.createDataForPlacingPositionSLTPOrder(
            data,
            orderTypes.Limit)

        tpData.parameterDict.limitPrice = newSLTP.TakeProfitPriceValue
        tpData.parameterDict[OrderEditBaseUtils.SLTP_TRIGGER] = SLTPTrigger.GetRawValue(newSLTP.SLTPTriggerShortValue, data.side, false)

        this.placeSLTPOrderForPosition(tpData, position, data.placedFrom)

        changed = changed || true;
    }

    //  Replace SL.
    if (canEditSLOrTrailingStop && setNewSL && positionHasSL && data.isSLchanged)
    {
        let slData = this.createDataForReplacingPositionSLTPOrder(position.SLOrder)
        slData.orderTypeId = setTrailingStop
            ? orderTypes.TrailingStop
            : stopOrderType

        slData.parameterDict[setTrailingStop ? OrderEditBaseUtils.TRAILING_STOP_PARAM : OrderEditBaseUtils.STOP_PRICE_PARAM] =
            newSLTP.StopLossPriceValue

        if (needSetSLL)
            slData.parameterDict[OrderEditBaseUtils.LIMIT_PRICE_PARAM] = stopLossLimitValue

        if (newSLTP.RealTrStopPrice)
            slData.parameterDict.RealTrStopPrice = newSLTP.RealTrStopPrice;

        slData.placedFrom = data.placedFrom
        promises.push(this.replaceOrder(slData))
    }

    //  Replace TP.
    if (canEditTP && setNewTP && positionHasTP && data.isTPchanged)
    {
        let tpData = this.createDataForReplacingPositionSLTPOrder(position.TPOrder)
        tpData.orderTypeId = orderTypes.Limit
        tpData.parameterDict.limitPrice = newSLTP.TakeProfitPriceValue

        tpData.placedFrom = data.placedFrom
        promises.push(this.replaceOrder(tpData))
    }

    if (promises.length)
        return Promise.all(promises).then((results) =>
        {
            for (let r of results)
                if (!r)
                    return false
            return true;
        });
    else
        return changed || data.UseSkipNoChange;
}

// TODO. Refactor.
// Метод, который позволяет определить доступный TIF для закрывающих ордеров
ProcessorWorker.getDefaultSLTPValidity = function (order, orderType)
{
    let tifEnum = OrderTif

    if (!order)
        return new TIF(tifEnum.GTC)

    let route = order.DataCache.getRouteByName(order.Route)
    if (!route)
        return new TIF(tifEnum.GTC)

    if (route.IsAllowableTif(tifEnum.GTC, orderType))
        return new TIF(tifEnum.GTC)

    //#37958 - По умолчанию на СЛ/ТП всегда ставим GTC,
    // если установить GTC невозможно, ставим для sl/tp ТИФ ордера
    if (route.IsAllowableTif(order.TimeInForce, orderType))
        return new TIF(order.TimeInForce)

    if (route.IsAllowableTif(tifEnum.Day, orderType))
        return new TIF(tifEnum.Day)

    if (route.IsAllowableTif(tifEnum.IOC, orderType))
        return new TIF(tifEnum.IOC)

    if (route.IsAllowableTif(tifEnum.FOK, orderType))
        return new TIF(tifEnum.FOK)

    if (route.IsAllowableTif(tifEnum.GTD, orderType))
        return new TIF(tifEnum.GTD, new Date(order.ExpireAt))

    return new TIF(tifEnum.GTC)
}

// TODO. Refactor. Ugly.
ProcessorWorker.prototype.createDataForPlacingPositionSLTPOrder = function (positionModifyData, sltpOrderType, placedFrom)
{
    let position = positionModifyData.position
    let sltpSide =
        position.BuySell === OperationType.Buy
            ? OperationType.Sell
            : OperationType.Buy

    let data = new OrderEditRequestData()
    data.orderTypeId = sltpOrderType
    data.instrument = positionModifyData.instrument
    data.account = positionModifyData.account
    data.quote = positionModifyData.quote
    data.side = sltpSide
    data.productType = positionModifyData.productType
    // TODO. Ugly.
    data.tif = ProcessorWorker.getDefaultSLTPValidity(position, sltpOrderType)

    return data
}

// TODO. Refactor. Ugly.
ProcessorWorker.prototype.createDataForReplacingPositionSLTPOrder = function (order)
{
    let data = new OrderEditRequestData()
    data.instrument = order.Instrument
    data.account = order.Account
    data.side = order.BuySell
    // TODO. Ugly. Remove?
    data.tif = new TIF(order.TimeInForce, new Date(order.ExpireAt))
    // TODO. Ugly. Remove?
    data.order = order

    return data
}

// TODO. Refactor. Ugly.
ProcessorWorker.prototype.placeSLTPOrderForPosition = function (sltpData, position, placedFrom)
{
    let sltpGroup = this.createOrderGroup(sltpData, placedFrom)
    if (!sltpGroup)
        return

    sltpGroup.setOpen(false)
    sltpGroup.setBoundTo(-1)
    this.setOrderGroupPrices(sltpData, sltpData.orderTypeId, sltpGroup)

    let boundToPositionGroup = new vendorGroup.OrderIdGroup()
    boundToPositionGroup.setOrderId(position.PositionId)
    sltpGroup.AddGroup(boundToPositionGroup)

    this.placeOrderGroups([sltpGroup], placedFrom)
}

// TODO. Answer. Promise.
ProcessorWorker.prototype.placeOrder = function (data)
{
    let orderGroups = null

    let ordTypes = OrderType
    let ordType = data.orderTypeId

    if (ordType === ordTypes.OCO)
    {
        orderGroups = this.createOCOGroups(data)
    }
    else
    {
        let orderGroup = this.createOrderGroup(data, data.placedFrom)
        if (!orderGroup)
            return

        this.setOrderGroupPrices(data, ordType, orderGroup)
        orderGroups = [orderGroup]
    }

    this.placeOrderGroups(orderGroups, data.placedFrom)
}

ProcessorWorker.prototype.placeOrderAsync = function (data) {
    let orderGroups = null
    let ordType = data.orderTypeId

    if (ordType === OrderType.OCO)
    {
        orderGroups = this.createOCOGroups(data)
    }
    else
    {
        const orderGroup = this.createOrderGroup(data, data.placedFrom)
        if (!orderGroup)
            return Promise.reject();

        this.setOrderGroupPrices(data, ordType, orderGroup)
        orderGroups = [orderGroup]
    }

    return this.placeOrderGroupsAsync(orderGroups, data.placedFrom)
}

// TODO. Answer. Promise.
ProcessorWorker.prototype.placeOrderGroups = function (orderGroups, placedFrom)
{
    let orderMessage = new vendorMessage.NewOrderMessage()
    orderMessage.setRequestId(orderMessage.getSequance())

    if (orderGroups)
        for (let i = 0, len = orderGroups.length; i < len; i++)
            orderMessage.FieldSet.AddGroup(orderGroups[i])

    orderMessage.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER)

    this.SendMessage(orderMessage)
}

ProcessorWorker.prototype.placeOrderGroupsAsync = async function (orderGroups, placedFrom) {
    const orderMessage = new vendorMessage.NewOrderMessage()
    const reqId = orderMessage.getSequance();
    orderMessage.setRequestId(reqId)

    if (orderGroups)
        for (let i = 0, len = orderGroups.length; i < len; i++)
            orderMessage.FieldSet.AddGroup(orderGroups[i])

    orderMessage.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER)
    const me = this;
    const msg = await new Promise((resolve, reject) => {
        me.WrappersHandlers[reqId] = resolve;
        me.SendMessage(orderMessage);
    });
    const response = msg[0] || msg;
    this.Notify(response);
    return response;
}

// TODO. Ugly. Details are in OCOOrderEdit.js
// TODO. Doesn't support StopLimit orders.
// TODO. Code duplication.
ProcessorWorker.prototype.createOCOGroups = function (data)
{
    let ordTypes = OrderType

    // TODO. Ewww. UGLY.
    let ocoCustomData = data.ocoCustomOrdersData

    let firstOrderSide = ocoCustomData ? ocoCustomData.firstOrderSide : data.side
    let secondOrderSide = ocoCustomData ? ocoCustomData.secondOrderSide : data.side

    let firstOrderTif = ocoCustomData ? ocoCustomData.firstOrderTif : data.tif
    let secondOrderTif = ocoCustomData ? ocoCustomData.secondOrderTif : data.tif

    let firstOrderType = ocoCustomData ? ocoCustomData.firstOrderType : ordTypes.Limit
    let secondOrderType = ocoCustomData ? ocoCustomData.secondOrderType : (data.useStopLimitInsteadStop ? ordTypes.StopLimit : ordTypes.Stop)

    // TODO. Doesn't support StopLimit.
    let firstOrderPrice = data.parameterDict.limitPrice
    let secondOrderPrice = data.parameterDict.stopPrice

    // First order ugly data mod.
    data.side = firstOrderSide
    data.tif = firstOrderTif
    // TODO. UGLY.
    data.parameterDict.limitPrice = ocoCustomData && ocoCustomData.firstOrderLimitPriceForStopLimit ? ocoCustomData.firstOrderLimitPriceForStopLimit : firstOrderPrice
    data.parameterDict.stopPrice = firstOrderPrice

    let firstOrderGroup = this.createOrderGroup(data, data.placedFrom)
    if (!firstOrderGroup)
        return
    firstOrderGroup.setOrderType(firstOrderType)
    this.setOrderGroupPrices(data, firstOrderType, firstOrderGroup)

    // Second order ugly data mod.
    data.side = secondOrderSide
    data.tif = secondOrderTif
    // TODO. UGLY.
    data.parameterDict.limitPrice = data.limitPriceForStopLimitOrder && secondOrderType === ordTypes.StopLimit ? data.limitPriceForStopLimitOrder : secondOrderPrice
    if (ocoCustomData && ocoCustomData.secondOrderLimitPriceForStopLimit)
        data.parameterDict.limitPrice = ocoCustomData.secondOrderLimitPriceForStopLimit
    data.parameterDict.stopPrice = secondOrderPrice

    let secondOrderGroup = this.createOrderGroup(data, data.placedFrom)
    if (!secondOrderGroup)
        return
    secondOrderGroup.setOrderType(secondOrderType)
    this.setOrderGroupPrices(data, secondOrderType, secondOrderGroup)

    secondOrderGroup.setOrderIdToLink(firstOrderGroup.getClientOrderId())
    secondOrderGroup.setOrderLinkType(ProcessorWorker.ORDER_LINK_CANCEL)

    firstOrderGroup.setOrderIdToLink(secondOrderGroup.getClientOrderId())
    firstOrderGroup.setOrderLinkType(ProcessorWorker.ORDER_LINK_CANCEL)

    return [firstOrderGroup, secondOrderGroup]
}

// TODO. Rename. Refactor.
ProcessorWorker.prototype.createOrderGroup = function (data, placedFrom)
{
    let decoder = this.FMsgDecoder

    if (PriceLimitValidation.SendRejectIfNotValidateLimits(data))  // #111427
        return null

    let acc = data.account
    let ins = data.instrument
    let quote = data.quote

    let group = new vendorGroup.OrderGroup()
    // TODO. Instead of object.GetHashCode()
    group.setClientOrderId(parseInt(Math.random() * 1000000))
    group.setOrderType(data.orderTypeId)
    group.setAccountId(parseInt(acc.AcctNumber))
    group.setProductType(parseInt(data.productType))
    group.setInstrumentTradableID(ins.InstrumentTradableID)
    group.setRouteId(ins.getRoute());
    group.setOperationType(data.side)

    if (data.quantity)
        group.setAmount(Quantity.toLots(data.quantity, ins))

    if (data.disclosedQuantity)
        group.setDisclosedQty(Quantity.toLots(data.disclosedQuantity, ins))
    else if (data.quantity)     // подробнее почему так: https://tp.traderevolution.com/entity/105398
        group.setDisclosedQty(Quantity.toLots(data.quantity, ins))

    let tif = data.tif
    group.setValidity(tif.type)
    if (tif.type === OrderTif.GTD)
        group.setTIFExpireDate(tif.expirationTime)

    if (data.leverageValue)
        group.setLeverage(parseInt(data.leverageValue))

    let orderParamDict = data.parameterDict
    let sltp = orderParamDict.sltp
    if (sltp)
    {
        if (!isNaN(sltp.StopLossPriceValue))
        {
            group.setSLPriceType(sltp.StopLossPriceType);
            group.setSLPrice(sltp.StopLossPriceValue)

            if (sltp.RealTrStopPrice && !orderParamDict.RealTrStopPrice)
                group.setPrice(sltp.RealTrStopPrice)

            if (sltp.SLTPTriggerShortValue !== null)
                group.setSLTriggerPrice(SLTPTrigger.GetRawValue(sltp.SLTPTriggerShortValue, data.side, true))
        }

        if (sltp.StopLossLimitPriceValue != null)
            group.setSLLimitPrice(sltp.StopLossLimitPriceValue)

        if (!isNaN(sltp.TakeProfitPriceValue))
        {
            group.setTPPriceType(sltp.TakeProfitPriceType)
            group.setTPPrice(sltp.TakeProfitPriceValue)

            if (sltp.SLTPTriggerShortValue !== null)
                group.setTPTriggerPrice(SLTPTrigger.GetRawValue(sltp.SLTPTriggerShortValue, data.side, false))
        }
    }

    group.setOpen(true)
    group.setByBroker(false)
    group.setIsByStrategy(false)
    group.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER)

    if (orderParamDict.RealTrStopPrice)
        group.setPrice(orderParamDict.RealTrStopPrice)

    if (data.comment)
        group.setComment(data.comment)

    return group
}

ProcessorWorker.prototype.replaceOrder = function (data)
{
    let msg = this.createReplaceOrderMessage(data)
    if (!msg) return

    let me = this;
    return new Promise(function (resolve, reject)
    {
        let rqi = msg.getSequance();
        msg.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;
        me.WrappersHandlersTrading[msg.getOrderId()] = resolve;
        me.SendMessage(msg)
    }).then(function (msg)
    {
        let m = msg[0] || msg;
        me.Notify(m)
        return m.Code !== DirectMessageCode.CODE_XML_REPORT;
    });
}

// TODO. Ugly. Refactor. Promise?
ProcessorWorker.prototype.createReplaceOrderMessage = function (data)
{
    let decoder = this.FMsgDecoder

    if (PriceLimitValidation.SendRejectIfNotValidateLimits(data))  // #111427
        return null

    let acc = data.account
    let ins = data.instrument
    let order = data.order
    let orderType = data.orderTypeId
    let orderParamDict = data.parameterDict

    let msg = new vendorMessage.OrderReplaceMessage()

    msg.setOrderId(BigInt(order.OrderNumber))
    msg.setOrderType(orderType)
    msg.setOperationType(data.side)
    msg.setAccountId(parseInt(acc.AcctNumber))
    msg.setInstrumentTradableID(ins.InstrumentTradableID)
    msg.setRouteId(ins.getRoute())
    msg.setPlacedFrom(data.placedFrom || PlacedFrom.WEB_OTHER)

    if (data.quantity)
        msg.setAmount(Quantity.toLots(data.quantity, ins))

    if (data.disclosedQuantity)
        msg.setDisclosedQty(Quantity.toLots(data.disclosedQuantity, ins))

    let tif = data.tif
    msg.setValidity(tif.type)
    if (tif.type === OrderTif.GTD)
        msg.setTIFExpireDate(tif.expirationTime)

    let orderTypes = OrderType

    // Setting up prices.
    switch (orderType)
    {
        case orderTypes.TrailingStop:
            msg.setFieldValue(FieldsFactory.FIELD_TR_OFFSET, orderParamDict.trailingStop)
            if (orderParamDict.RealTrStopPrice)
                msg.setPrice(orderParamDict.RealTrStopPrice)
            break
        case orderTypes.Stop:
            msg.setPrice(orderParamDict.stopPrice)
            break
        case orderTypes.StopLimit:
            msg.setPrice(orderParamDict.limitPrice)
            msg.setStopPrice(orderParamDict.stopPrice)
            break
        case orderTypes.Limit:
            msg.setPrice(orderParamDict.limitPrice)
            break
    }

    // Setting up sl/tp.
    let sltp = orderParamDict.sltp
    if (sltp)
    {
        msg.setFieldValue(FieldsFactory.FIELD_SL_PRICE_TYPE, sltp.StopLossPriceType)
        msg.setFieldValue(FieldsFactory.FIELD_SL_PRICE, sltp.StopLossPriceValue)
        msg.setFieldValue(FieldsFactory.FIELD_TP_PRICE_TYPE, sltp.TakeProfitPriceType)
        msg.setFieldValue(FieldsFactory.FIELD_TP_PRICE, sltp.TakeProfitPriceValue)
        if (sltp.StopLossLimitPriceValue != null && !isNaN(sltp.StopLossPriceValue))
            msg.setSLLimitPrice(sltp.StopLossLimitPriceValue === null ? NaN : sltp.StopLossLimitPriceValue)     // шлём на сервер NaN вместо null

        if (sltp.SLTPTriggerShortValue)
        {
            if (!isNaN(sltp.StopLossPriceValue) || sltp.StopLossLimitPriceValue != null)
                msg.setSLTriggerPrice(SLTPTrigger.GetRawValue(sltp.SLTPTriggerShortValue, data.side, true))

            if (!isNaN(sltp.TakeProfitPriceValue))
                msg.setTPTriggerPrice(SLTPTrigger.GetRawValue(sltp.SLTPTriggerShortValue, data.side, false))
        }
    }

    let boundToVal = 'boundTo' in orderParamDict
        ? orderParamDict.boundTo
        : -1

    if (boundToVal === NO_BIND_TO)
        boundToVal = -1

    msg.setBoundTo(boundToVal)

    // TODO.
    let group = new vendorGroup.OrderGroup()
    group.setByBroker(false)
    msg.FieldSet.AddGroup(group)

    return msg
}

// TODO. Rename. Refactor.
ProcessorWorker.prototype.setOrderGroupPrices = function (data, orderType, group)
{
    let orderParamDict = data.parameterDict
    let ordTypes = OrderType

    let acc = data.account
    let ins = data.instrument
    let quote = data.quote
    let buy = data.side === OperationType.Buy

    switch (orderType)
    {
        case ordTypes.Stop:
            group.setPrice(orderParamDict.stopPrice)
            group.setStopPrice(0)
            break
        case ordTypes.StopLimit:
            group.setPrice(orderParamDict.limitPrice)
            group.setStopPrice(orderParamDict.stopPrice)
            break
        case ordTypes.Limit:
            group.setPrice(orderParamDict.limitPrice)
            group.setStopPrice(0)
            break
        case ordTypes.TrailingStop:
            // let linkPrice = 0
            // if (quote)
            //     linkPrice = buy
            //         ? quote.AskSpread_SP_Ins(DataCache.GetSpreadPlan(), ins)
            //         : quote.BidSpread_SP_Ins(DataCache.GetSpreadPlan(), ins)

            if (orderParamDict.RealTrStopPrice)
                group.setPrice(orderParamDict.RealTrStopPrice)

            // group.setPrice(linkPrice || 0)
            group.setTrailingOffset(orderParamDict.trailingStop)
            break
    }

    let trigger = orderParamDict[OrderEditBaseUtils.SLTP_TRIGGER]
    if (trigger)
        group.setSLTPTriggerPrice(trigger)

}

// TODO. Answer. Promise.
ProcessorWorker.prototype.cancelOrder = function (order, placedFrom)
{
    if (!order) return

    let msgDecoder = this.FMsgDecoder

    let message = new vendorMessage.CancelOrderMessage()
    message.setOrderId(order.OrderNumber)
    message.setAccountId(order.Account.BstrAccount)
    message.setInstrumentTradableID(order.Instrument.InstrumentTradableID)
    message.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER)

    //let fromName = GetCorrectFromName(ord.Account, fromName)
    //let isBrokerRequest = IsBrokerRequest(ord.Account, fromName);
    let isBrokerRequest = false
    message.setIsBrokerRequest(isBrokerRequest)

    message.setRequestId(message.getSequance())

    this.SendMessage(message)
}

// TODO. Answer. Promise.
ProcessorWorker.prototype.closePositions = function (closePositionData, placedFrom)
{
    const positions = closePositionData.positions;
    const tifsObj = closePositionData.closingOrderTifDict;
    const mutualPositionsIds = closePositionData.mutualPositionIDs;

    let msg = new vendorMessage.NewOrderMessage();

    for (let posID in positions)
        this.addOrderGroupToClosePosition(msg, positions[posID], closePositionData.quantityToClose, tifsObj[posID], placedFrom, mutualPositionsIds);

    msg.setRequestId(msg.getSequance());
    this.SendMessage(msg);
}

ProcessorWorker.prototype.addOrderGroupToClosePosition = function (msg, pos, quantityToClose, tifObj, placedFrom, mutualPositionsIds)
{
    const acc = pos.Account;
    const ins = pos.Instrument;
    const quote = ins.LastQuote;

    if (mutualPositionsIds && mutualPositionsIds[0] != pos.PositionId)
        return;

    let group = new vendorGroup.OrderGroup();
    msg.addGroup(group);

    // TODO. Instead of object.GetHashCode()
    group.setClientOrderId(parseInt(Math.random() * 1000000));
    group.setInstrumentTradableID(ins.InstrumentTradableID);
    group.setAccountId(parseInt(acc.BstrAccount));
    group.setOperationType(pos.BuySell);
    group.setProductType(pos.ProductType);
    // group.setLeverage(pos.leverageValue)
    group.setBoundTo(-1);

    group.setValidity(tifObj.type);
    if (tifObj.type === OrderTif.GTD)
        group.setTIFExpireDate(tifObj.expirationTime);

    let price = 0;
    if (quote)
    {
        let sp = pos.DataCache.GetSpreadPlan(acc);
        price = pos.BuySell === OperationType.Buy
            ? quote.BidSpread_SP_Ins(sp, ins)
            : quote.AskSpread_SP_Ins(sp, ins);

        if (isNaN(price))
            price = 0;
    }

    group.setPrice(price);
    group.setStopPrice(0);

    let lotsToClose = quantityToClose ? Quantity.toLots(quantityToClose, ins) : pos.Amount;
    group.setAmount(lotsToClose);

    group.setOrderType(OrderType.Market);
    // TODO.
    group.setByBroker(false);
    group.setOpen(false);
    group.setIsByStrategy(false);
    group.setRouteId(-1);
    group.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER);

    let posList = mutualPositionsIds ? mutualPositionsIds : [pos.OrderNumber];

    for (let i = 0, len = posList.length; i < len; i++)
    {
        let posId = BigInt(posList[i]);
        let orderIdGroup = new vendorGroup.OrderIdGroup();
        orderIdGroup.setOrderId(posId);
        group.AddGroup(orderIdGroup);
    }
}

// TODO. Answer. Promise.
// TODO. Refactor. Move to modifyOrder()?
ProcessorWorker.prototype.changeOrderToMarket = function (order, placedFrom)
{
    let msg = new vendorMessage.OrderReplaceMessage()

    msg.setOrderType(OrderType.Market)
    msg.setOrderId(BigInt(order.OrderNumber))
    msg.setRequestId(msg.getSequance())
    msg.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER)

    this.SendMessage(msg)
}

ProcessorWorker.prototype.modifyPositionProductType = function (positionId, productType, quantity)
{
    let msg = new vendorMessage.ModifyPositionMessage()

    msg.setPositionId(BigInt(positionId));
    msg.setProductType(parseInt(productType));
    let rqi = msg.getSequance();
    msg.setRequestId(rqi);
    msg.setQuantity(quantity)
    return new Promise(
        (resolve, reject) =>
        {
            this.WrappersHandlers[rqi] = resolve;
            this.SendMessage(msg);
        }).then((msg) =>
        {
            msg = msg[0];
            if (!msg)
                return;

            if (msg.IsDirect && msg.Code === DirectMessageCode.CODE_XML_REPORT)
                msg.Name = "Product type modification rejected";
            this.Notify(msg);
        })

}

ProcessorWorker.prototype.sendTradePassword = function (pass, ExternalResourse)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let message = new vendorMessage.PfixOneTimePasswordMessage();

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(message)
    }).then(function (msg)
    {
        msg = msg[0];

        let message = new vendorMessage.TradingUnlockMessage();

        if (ExternalResourse)
            message.setExternalResourse(ExternalResourse);

        let rqi = message.getSequance();
        message.setRequestId(rqi);

        let pr = null;
        let EncrType = msg.EncryptionType();
        if (EncrType !== EncrTypes.AES_GCM_NoPadding)
            pr = ProXOREncryptionUtility.Encode(pass, msg.GetPassword())
                .then((encrPass) =>
                {
                    message.SetPassword(encrPass)
                    return true;
                });
        else
            pr = EncodeKey_AES_GCM_NoPadding(pass, msg.GetPassword())
                .then((encrPass) =>
                {
                    message.SetPassword(encrPass);
                    return true
                })
        return pr.then(() =>
        {
            return new Promise(function (resolve, reject)
            {
                me.WrappersHandlers[rqi] = resolve;
                me.SendMessage(message)
            })
        })
    }).then(function (msg)
    {
        msg = msg[0];
        return msg.getTradingUnlocked();
    });
}

ProcessorWorker.prototype.SendSOAPRequest = function (request)
{
    let me = this;
    return new Promise(function (resolve, reject)
    {
        let ff = FieldsFactory;
        let soapReqMsg = new vendorMessage.SOAPReqMessage();
        ProcessorWorker.AddProtocolVersonAndMaxField(soapReqMsg)
        soapReqMsg.setName("");
        soapReqMsg.setFieldValue(ff.FIELD_MAX_PFIX_FIELD_INDEX, ff.getInstance().MaxFieldNumber);

        if (request === null)
            reject("Bad Arguments")

        let keys = Object.keys(request);

        if (!keys.length)
            reject("Bad Arguments")

        for (let i = 0; i < keys.length; i++)
        {
            let parName = keys[i];
            let parValue = request[parName];
            let group = new vendorGroup.KeyValueAggregateGroup();
            group.setKey(parName);
            group.setValue(parValue);
            soapReqMsg.FieldSet.AddGroup(group);
        }

        let rqi = soapReqMsg.getSequance();
        soapReqMsg.setRequestId(rqi);

        me.WrappersHandlers[rqi] = resolve;

        me.SendMessage(soapReqMsg)
    })
        .then(function (msg)
        {
            msg = msg[0];
            let gr = msg.FieldSet.GetGroups(FieldsFactory.LINE_GROUP_NAME);
            if (!gr.length)
                return "Bad Arguments";
            return gr[0].GetValue(FieldsFactory.FIELD_TEXT)
        });
}


ProcessorWorker.prototype.SendVerifySessionMsg = function (sessId)
{
    let msg = new vendorMessage.TokenVerifyRequestMessage();
    msg.SetUserSessionId(sessId);
    ProcessorWorker.AddProtocolVersonAndMaxField(msg)
    this.SendMessage(msg)
}

ProcessorWorker.prototype.ProcessVerifySessionMsg = function (msg)
{
    let answer = { IsExpired: true, Login: null, Opened: true };

    if (msg.Code === DirectMessageCode.CODE_XML_REPORT)
        ;
    else if (msg.Code === DirectMessageCode.CODE_PFIX_TOKEN_VERIFY_RESPONSE)
    {
        answer.IsExpired = msg.IsExpired;
        answer.Login = msg.Login;
    }
    return answer;
}

ProcessorWorker.SendTokenVerifyMessage = function (url, isSSL, sessId, sert)
{
    let myStream = ProcessorWorker.CreateMyObj(url, isSSL);

    return myStream.OpenWS(sert).then(function (opened)
    {
        if (!opened)
            return { IsExpired: true, Login: null, Opened: false }
        myStream.SendVerifySessionMsg(sessId)
        return myStream.MyPrommisseHandler;
    })
    //TODO
    // .CloseStream();
}

ProcessorWorker.GetSessionLessBrandingRules = function (url, isSSL, brandingKey, sert)
{
    let myStream = ProcessorWorker.CreateMyObj(url, isSSL);

    return myStream.OpenWS(sert).then(function (opened)
    {
        if (!opened)
            return { Opened: false }
        return myStream.GetBrandingRules(brandingKey).then(function (msg)
        {
            let data = null
            if (msg)
                data = msg[0] || msg;
            if (data.Code === DirectMessageCode.CODE_XML_REPORT)
                data = null
            return { Opened: true, Data: data };
        })
    })

    //TODO
    // .CloseStream();
}

ProcessorWorker.CreateMyObj = function (url, isSSL)
{
    let stream = new ProcessorWorker(ProcessorWorker.MODE_AUTHENTICATION_REQUEST);
    stream.siteAddres = url;
    stream.isSSL = isSSL;
    stream.MyPrommisseHandler = new Promise(function (resolve, reject)
    {
        stream.OnError = reject;
        stream.OnNewMessageDelegate = function (msg)
        {
            resolve(stream.ProcessVerifySessionMsg(msg));
        }
    }).catch(function (errorResovingFunc)
    {
        errorResovingFunc(false)
    });
    return stream;
}

ProcessorWorker.prototype.SendAlertToServer = function (alertData)
{
    let isNew = alertData.AlertId === null;

    let msgToSend = null;
    if (isNew)
        msgToSend = new vendorMessage.CreateAlertMessage();
    else
        msgToSend = new vendorMessage.ReplaceAlertMessage();

    if (isNew)
        ;//немогут определиться
    // msgToSend.setUserId(alertData.Account.userPin)
    else
        msgToSend.setAlertId(alertData.AlertId);

    msgToSend.setTradableInstrumentId(alertData.Instrument.InstrumentTradableID)
    msgToSend.setRouteId(alertData.Instrument.Route)
    msgToSend.setAlertType(alertData.AlertType)
    msgToSend.setAlertCondition(alertData.Condition)
    msgToSend.setAlertValue(alertData.Value)
    msgToSend.setAlertImportance(alertData.Importance)
    msgToSend.setAlertDate(alertData.Expiration)
    msgToSend.setAlertAfterExecute(alertData.AfterExecute)
    msgToSend.setAlertAction(alertData.Action)
    msgToSend.setAlertNotification(alertData.Notification)
    msgToSend.setAlertText(alertData.MessageText)

    if (alertData.leverageValue)
        msgToSend.setAlertLeverage(alertData.leverageValue)

    let data = alertData.OrderPlaceParametrs
    if (data)
    {
        let orderGroups = null
        let ordTypes = OrderType
        let ordType = data.orderTypeId

        if (ordType === ordTypes.OCO)
            orderGroups = this.createOCOGroups(data)
        else
        {
            let orderGroup = this.createOrderGroup(data, data.placedFrom)
            if (!orderGroup)
                return

            this.setOrderGroupPrices(data, ordType, orderGroup)
            orderGroups = [orderGroup]
        }

        for (let i = 0, len = orderGroups.length; i < len; i++)
            msgToSend.FieldSet.AddGroup(orderGroups[i])
    }

    msgToSend.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL_ID, PlacedFrom.WEB_ALERT)
    this.SendMessage(msgToSend);
}

ProcessorWorker.prototype.MakeAlertAction = function (alertActionInfo)
{
    let msg = new vendorMessage.ControlAlertCommandMessage();
    msg.setAlertId(alertActionInfo.AlertId);
    msg.setAlertCommand(alertActionInfo.Command);
    this.SendMessage(msg);
}

ProcessorWorker.prototype.SendProductSubscriptionRequest = function (Data)
{
    var pfixSubscribeRequestMsg = new vendorMessage.PFixEntitlementSubscriptionRequestMessage();
    pfixSubscribeRequestMsg.setProductId(Data.ProductId);
    pfixSubscribeRequestMsg.setRequestType(Data.RequestType);

    for (let i = 0; i < Data.EntitlmentDocuments.length; i++)
    {
        let doc = Data.EntitlmentDocuments[i];
        var docGroup = vendorGroup.EntitlementDocumentGroup.CreateDocument(doc.Id, doc.Name, doc.Content);
        pfixSubscribeRequestMsg.AddDocument(docGroup);
    }

    let rqi = pfixSubscribeRequestMsg.getSequance();
    pfixSubscribeRequestMsg.setRequestId(rqi);

    let me = this;
    return new Promise(function (resolve, reject)
    {
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(pfixSubscribeRequestMsg);
    }).then(function (newMsg)
    {
        if (newMsg)
            for (let i = 0; i < newMsg.length; i++)
            {
                let msg = newMsg[i]
                if (msg.Code === DirectMessageCode.CODE_XML_REPORT)
                    msg.ReqProductId = Data.ProductId;
                me.Notify(msg)
            }
    });
}

ProcessorWorker.prototype.SendProductDocumentRequest = function (ProductId)
{
    var pfixGetDocRequestMsg = new vendorMessage.PFixEntitlementProductDocumentRequestMessage();
    pfixGetDocRequestMsg.setProductId(ProductId);

    let rqi = pfixGetDocRequestMsg.getSequance();
    pfixGetDocRequestMsg.setRequestId(rqi);

    let me = this;
    return new Promise(function (resolve, reject)
    {
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(pfixGetDocRequestMsg);
    })
}

ProcessorWorker.prototype.SendSubscriptionHistoryReques = function (from, to)
{
    var pfixSubscriptionHistory = new vendorMessage.PfixEntitlementSubscriptionHistoryRequestMessage();
    pfixSubscriptionHistory.setFromUtc(from);
    pfixSubscriptionHistory.setToUtc(to);

    let rqi = pfixSubscriptionHistory.getSequance();
    pfixSubscriptionHistory.setRequestId(rqi);

    let me = this;
    let resArray = new Array();
    return new Promise(function (resolve, reject)
    {
        me.WrappersHandlers[rqi] = resolve;
        me.SendMessage(pfixSubscriptionHistory);
    }).then(function (msg)
    {
        return me.SendSubscriptionHistoryResponseCollect(msg, rqi, resArray)
    });
}

ProcessorWorker.prototype.SendSubscriptionHistoryResponseCollect = function (msg, rqi, resArray)
{
    let m = msg[0];
    resArray.push(m);
    if (m.ResponseEnd)
        return Promise.resolve(resArray)

    let me = this;
    return new Promise(function (resolve, reject)
    {
        me.WrappersHandlers[rqi] = resolve;
    }).then(function (newMsg)
    {
        return me.SendSubscriptionHistoryResponseCollect(newMsg, rqi, resArray)
    });

}

ProcessorWorker.AddProtocolVersonAndMaxField = function (msg)
{
    if (!msg || !msg.setFieldValue)
        return;
    let protocolVerson = "1.13";
    msg.setFieldValue(FieldsFactory.FIELD_PROTOCOL_ID, protocolVerson);
    msg.setFieldValue(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX, FieldsFactory.getInstance().MaxFieldNumber);

    const clientType = ClientType.getClientType();
    msg.setFieldValue(FieldsFactory.FIELD_CLIENT_TYPE, clientType);
}

// #endregion Trading


ProcessorWorker.prototype.SendPasswordRecoveryChangeRequest = function (data)
{
    let recoveryReq = new vendorMessage.PasswordRecoveryChangeRequest();
    if (data.newPassword)
        recoveryReq.setPassword(data.newPassword);
    if (data.login)
        recoveryReq.setLogin(data.login);
    if (data.accessToken)
        recoveryReq.setAccessToken(data.accessToken);   // #92068
    recoveryReq.setKey(data.key);
    ProcessorWorker.AddProtocolVersonAndMaxField(recoveryReq);

    let rqi = recoveryReq.getSequance();
    recoveryReq.setRequestId(rqi);
    return new Promise((resolve, reject) =>
    {
        this.WrappersHandlers[rqi] = resolve;
        this.SendMessage(recoveryReq);
    }).then((msg) =>
    {
        msg = msg[0];
        if (msg.IsDirect)
            return Promise.resolve({ status: 10000, BusinessRejectCode: msg.BusinessRejectCode, errText: msg.Data[0][1] }); //years

        let status = msg.getStatus();
        let minLength = msg.getMinLength();
        let maxLength = msg.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH) || 128;

        return Promise.resolve({ status: status, minLength: minLength, MaxLength: maxLength });
    });
}

ProcessorWorker.prototype.SendRequestRecoveryPassword = function (data)
{
    let recoveryReq = new vendorMessage.RequestRecoveryPassword();
    if (data.login)
        recoveryReq.setLogin(data.login);
    if (data.email)
        recoveryReq.setEmail(data.email);

    ProcessorWorker.AddProtocolVersonAndMaxField(recoveryReq);

    let rqi = recoveryReq.getSequance();
    recoveryReq.setRequestId(rqi);
    return new Promise((resolve, reject) =>
    {
        this.WrappersHandlers[rqi] = resolve;
        this.SendMessage(recoveryReq);
    }).then((msg) =>
    {
        msg = msg[0];
        if (msg.IsDirect)
            return Promise.resolve({ status: 10000, BusinessRejectCode: msg.BusinessRejectCode, errText: msg.Data[0][1] }); //years

        let status = msg.getStatus();
        let minLength = msg.getMinLength();
        let maxLength = msg.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH) || 128;

        return Promise.resolve({ status: status, minLength: minLength, MaxLength: maxLength });
    });
}

ProcessorWorker.prototype.SendCloseAccountRequestMessage = function ()
{
    return new Promise((resolve, reject) =>
    {
        const message = new vendorMessage.CloseAccountRequestMessage();
        const rqi = message.getSequance();

        message.setRequestId(rqi);
        this.WrappersHandlers[rqi] = resolve;

        this.SendMessage(message);
    }).then((msgArr) =>
    {
        const msg = msgArr[0] || msgArr;
        this.Notify(msg)
        return msgArr;
    });
}

ProcessorWorker.prototype.SendCloseAccountCancelRequestMessage = function (closeAccountRequestID)
{
    return new Promise((resolve, reject) =>
    {
        const message = new vendorMessage.CloseAccountCancelRequestMessage();
        message.setCloseAccountRequestID(closeAccountRequestID);

        this.SendMessage(message);
    });
}

//#region Constants

ProcessorWorker.CONNECTED = 0;
ProcessorWorker.RECONNETING = 1;
ProcessorWorker.DISCONNECTED = 2;

ProcessorWorker.SOKET_MESSAGE_MODE_INFO = 0;
ProcessorWorker.SOKET_MESSAGE_MODE_UPLOAD = 2;
ProcessorWorker.SOKET_MESSAGE_MODE_DELETE = 3;
ProcessorWorker.SOKET_MESSAGE_MODE_NEW_FORMAT = 4;


ProcessorWorker.HistorySortOrder_Ascending = 0;
ProcessorWorker.HistorySortOrder_Descending = 1;
ProcessorWorker.MAX_BARS_TO_READ = 400000;

/// <summary>
/// Режим работы вендора - только котировки
/// </summary>
ProcessorWorker.MODE_AUTHENTICATION_REQUEST = 0x00;
/// <summary>
/// Режим работы вендора - только котировки
/// </summary>
ProcessorWorker.MODE_QUOTESTREAM = 0x01;
/// <summary>
/// Режим работы вендора - торговля
/// </summary>
ProcessorWorker.MODE_TRADESTREAM = 0x02;
/// <summary>
/// Режим работы вендора - история
/// </summary>
ProcessorWorker.MODE_HISTORYSTREAM = 0x04;
/// <summary>
/// Режим работы вендора - новости
/// </summary>
ProcessorWorker.MODE_NEWSTREAM = 0x08;

/// <summary>
/// Редим работы вендора - один сервер на все
/// </summary>
ProcessorWorker.MODE_SINGLE_SERVER = ProcessorWorker.MODE_QUOTESTREAM | ProcessorWorker.MODE_TRADESTREAM | ProcessorWorker.MODE_HISTORYSTREAM;

//#endregion

// TODO. Move?
// use to bound oco orders
ProcessorWorker.ORDER_LINK_CANCEL = 0

//#region Enums
export const CallingContext = { Normal: 0, Technical: 1 }

export const ExternalResource = { HUB: 2, SOCOPA: 3, OPTIMUS: 6, TERRA: 7 }

export const EncrTypes = { STANDART: 0, AES_GCM_NoPadding: 2 }

//#endregion Enums